import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableStructure from "./components/TableStructure/TableStructure";
import TableKitchenTiming, { TableServingTimingProvider } from "./components/TableKitchenTiming";
import RequestBadgeCluster from "./components/RequestBadgeCluster/RequestBadgeCluster";
import "./table-layout.css";
import Navbar from "../../ecommerce/posnavbar/Navbar";
import moment from "moment";
import { Box, CircularProgress, Modal } from "@mui/material";
import {
  getTableLayoutHierarchy,
  restaurantCreateCart,
  getAllTablesByAreaId,
  CreateRestaurantOrder,
  getTableStatusByCart,
  payOrderSplit,
  dataRetriveWhenPageRefresh,
  getOrderDetails,
  restaurantCartClose,
  orderStatusRetry,
  addCustomer,
  // AddedCustomerData,
  createB2CcustomerApi,
  createAddress,
} from "../../../config/Services";
import PaymentModal from "../product/all-products/components/twoWaykeyboardPaymentPage/components/paymentModal";
import cashNew from "../../../assets/images/cash-new.png";
import cashNewSelected from "../../../assets/images/cash-new-selected.png";
import cardNew from "../../../assets/images/card-new.png";
import cardNewSelected from "../../../assets/images/card-new-selected.png";
import upiNew from "../../../assets/images/upi-new.png";
import upiNewSelected from "../../../assets/images/upi-new-selected.png";
import splitNew from "../../../assets/images/split-new.png";
import splitNewSelected from "../../../assets/images/split-new-selected.png";
import usePrint from "../product/hooks/usePrint";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "../product/hooks/SnackbarProvider";
import { UserContext } from "../../../App";
import TableDetailsModal from "./components/TableDetailsModal/TableDetailsModal";
import SecondaryTopbar from "./components/SecondaryTopbar/SecondaryTopbar";
import { PosCustomButton } from "../../../customComponents/PosCustomButton/PosCustomButton";
import PosCustomIcon from "../../../customComponents/PosCustomIcon/PosCustomIcon";
import {
  ChartPieIcon,
  ClipboardDocumentListIcon,
  Cog8ToothIcon,
  ComputerDesktopIcon,
  DocumentPlusIcon,
  TableCellsIcon,
  QueueListIcon,
  PrinterIcon,
  BanknotesIcon,
} from "@heroicons/react/24/outline";

import ToggleOffOutlinedIcon from "@mui/icons-material/ToggleOffOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";

import TableConfirmationModal from "./components/TableConfirmationModal/TableConfirmationModal";
import TakeawayDeliveryModal from "./components/TakeawayDeliveryModal/TakeawayDeliveryModal";
import {
  changePrevAddedTime,
  eventTrackerTime,
} from "../product/all-products/redux/Actions/eventTracker";
import { getMobilePos } from "../product/all-products/redux/Reducers/paginationReducer";
import orderDisplayIcon from "../../../assets/images/order-display-icon.png";
import { addcoupon } from "../product/all-products/redux/Actions/couponActions";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import RepartitionIcon from "@mui/icons-material/Repartition";
import { usePrinterAgentStatus } from "../../../context/PrinterAgentContext";
import useGetDevice from "../product/hooks/useGetDevice";
import MenuAvailabilityDrawer from "./components/MenuAvailabilityDrawer";
import {
  startNotificationPolling,
  subscribeOrderNotification,
} from "../../../utils/notificationSystem/orderNotificationPollingService";
import {
  startTableTaskPolling,
  subscribeTableTasks,
} from "../../../utils/notificationSystem/tableTaskPollingService";

const style = {
  width: "100%",
  height: "100%",
  bgcolor: "#F5F5F5",
  overflow: "auto",
  padding: "10px",
};

const SELECTED_FLOOR_AREA_KEY = "restaurant_selected_floor_area";
const LAST_SELECTED_TABLE_KEY = "restaurant_last_selected_table";
const AREAS_STORAGE_KEY = "restaurant_areas";
const FLOORS_STORAGE_KEY = "restaurant_floors";
const HIERARCHY_DATA_KEY = "restaurant_hierarchy_data";
const TABLES_CACHE_PREFIX = "restaurant_tables_";
const MY_TABLES_KEY = "restaurant_my_tables";

const isTableOccupied = (status) => status === "OCCUPIED";

// Maps the backend's waiter-task action to the RequestBadgeCluster type key.
// REQUEST_FOR_PAY_BILL has no badge in this cluster (out of scope for now).
const TASK_ACTION_TO_TYPE = {
  REQUEST_FOR_ASSISTANCE: "assistance",
  REQUEST_FOR_BILL: "bill",
  REQUEST_FOR_WATER: "water",
  REQUEST_FOR_ORDER_UPDATES: "order-update",
};

const RestaurantReservationUI = ({
  cartItems: cartItemsProp,
  setCartItems: setCartItemsProp,
  handleOptionChange = () => {},
  setComments = () => {},
  setComplimentaryMode = () => {},
  setmarkWholeCartComplimentary = () => {},
  setCartStatus = () => {},
  setPrintedBillOrderId = () => {},
  setIsBillPrinted = () => {},
  syncCartDiscountState,
}) => {
  const {
    saleMode,
    setSaleMode,
    cartItems: cartItemsContext,
    setCartItems: setCartItemsContext,
    menuAvailabilityOpen,
    setMenuAvailabilityOpen,
    setTableLayoutRefetch,
    setTableLayoutStats,
  } = useContext(UserContext);
  const cartItems = cartItemsProp ?? cartItemsContext;
  const setCartItems = setCartItemsProp ?? setCartItemsContext;
  const [tableLayoutData, setTableLayoutData] = useState([]);
  const [floorPlan, setFloorPlan] = useState([]);
  const [multiLevelData, setMultiLevelData] = useState([]);
  const [floorCapacity, setFloorCapacity] = useState(0);
  const [selectedFloor, setSelectedFloor] = useState();
  const [selectedAreaId, setSelectedAreaId] = useState(null); // null = show All areas
  const [allAreasLayouts, setAllAreasLayouts] = useState({}); // { [areaId]: { mapId, entityName, children } }
  const [selectedLayout, setSelectedLayout] = useState({});
  const [loader, setLoader] = useState(false);
  const [tableSelectionLoader, setTableSelectionLoader] = useState({});
  const [tableDetailsModalOpen, setTableDetailsModalOpen] = useState(false);
  const [selectedTableMapId, setSelectedTableMapId] = useState("");
  const [canceledTable, setCanceledTable] = useState();
  const [activeChip, setActiveChip] = useState("OCCUPIED");
  const [tableConfirmationModalOpen, setTableConfirmationModalOpen] = useState(false);
  const [pendingTableData, setPendingTableData] = useState(null);
  const [pendingLayoutName, setPendingLayoutName] = useState("");
  const [orderDetailsModalOpen, setOrderDetailsModalOpen] = useState(false);
  const [pendingOrderMode, setPendingOrderMode] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [lastSelectedTableId, setLastSelectedTableId] = useState(null);
  const [tablesLoading, setTablesLoading] = useState(false);
  const [statusRefreshing, setStatusRefreshing] = useState(false);
  const [focusedTableIndex, setFocusedTableIndex] = useState(-1);
  const forceRefreshRef = useRef(false);
  const pendingRefreshTimerRef = useRef(null);

  const {
    setSelectedTable,
    setCartId,
    setCartTotalQty,
    setCustomerName,
    setCustomerMobileNumber,
    setSgst,
    setCess,
    setCgst,
    setSubTotal,
    setTotalValue,
    setTotal,
    tableSelectionModalOpen,
    setTableSelectionModalOpen,
    setCategoryName,
  } = useContext(UserContext);
  const isMobilePos = useSelector(getMobilePos);
  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");
  const layoutId = localStorage.getItem("layoutId");
  const retailUserLocalStorageData = useMemo(
    () => JSON.parse(localStorage.getItem("retailUserDetails") || "{}"),
    []
  );
  const licenseId = localStorage.getItem("licenseId");
  const licenseName = localStorage.getItem("licenseName");
  const sessionId = localStorage.getItem("sessionId");
  const branchSubType = localStorage.getItem("branchSubType");
  const retailType = localStorage.getItem("retailType");
  const cartIdFromLocal = localStorage.getItem("CartId");

  const [viewMode, setViewMode] = useState("grid");

  const [tableActionLoader, setTableActionLoader] = useState({});
  const { startPrint, openDrawer, isPrinting, isError } = usePrint();

  // Payment modal states
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [paymentTableData, setPaymentTableData] = useState(null);
  const [tpPaymentMethod, setTpPaymentMethod] = useState("CASH");
  const [tpEnterAmount, setTpEnterAmount] = useState("");
  const tpEnterAmountRef = useRef(null);
  const [tpTotal, setTpTotal] = useState(0);
  const [tpCartItems, setTpCartItems] = useState([]);
  const [tpPaymentLoader, setTpPaymentLoader] = useState(false);
  const [tpPaymentSuccess, setTpPaymentSuccess] = useState(false);
  const [tpPaymentFailed, setTpPaymentFailed] = useState(false);
  const [tpPaymentCancel, setTpPaymentCancel] = useState(false);
  const [tpNewLoader, setTpNewLoader] = useState(false);
  const [tpModalLoader, setTpModalLoader] = useState(false);
  const [tpPayLoader, setTpPayLoader] = useState(false);
  const [tpSplitActive, setTpSplitActive] = useState(false);
  const [tpPartialStatus, setTpPartialStatus] = useState(false);
  const [tpAmountPaid, setTpAmountPaid] = useState("");
  const [tpAmountDue, setTpAmountDue] = useState("");
  const [tpCashChange, setTpCashChange] = useState(false);
  const [tpNewId, setTpNewId] = useState(null);
  const [tpManual, setTpManual] = useState(false);
  const [tpCancelLoader, setTpCancelLoader] = useState(false);
  const [tpOrderSummary, setTpOrderSummary] = useState(null);
  const [isODSBlinking, setIsODSBlinking] = useState(false);
  const [tableTasks, setTableTasks] = useState([]);

  // Printer agent status - just read the state, polling happens in Cart page
  const { isPrinterOnlineForLocation } = usePrinterAgentStatus();

  const { startServerPolling, stopServerPolling } = usePrinterAgentStatus();

  // Start server polling when component mounts (for restaurant with cloud print enabled)
  useEffect(() => {
    // Check if cloud print is enabled
    let cloudPrintEnabled = false;
    try {
      const appConfig = JSON.parse(localStorage.getItem("appConfig"));
      cloudPrintEnabled = appConfig?.all?.CLOUD_PRINT?.flag === true;
    } catch {
      cloudPrintEnabled = false;
    }

    if (retailType === "RESTAURANT" && cloudPrintEnabled) {
      startServerPolling();
    }
    return () => {
      stopServerPolling();
    };
  }, [startServerPolling, stopServerPolling, retailType]);

  useEffect(() => {
    const unsubscribe = subscribeOrderNotification(({ hasCreatedOrders }) => {
      setIsODSBlinking(hasCreatedOrders);
    });
    startNotificationPolling();

    return () => {
      unsubscribe();
    };
  }, []);

  // Waiter table-task requests (water/bill/assistance/order-updates) — same
  // singleton poller the navbar's Live Updates island subscribes to, so this
  // is a second subscriber, not a second timer. Restaurant-only.
  useEffect(() => {
    if (retailType !== "RESTAURANT") {
      setTableTasks([]);
      return;
    }
    const unsubscribe = subscribeTableTasks(setTableTasks);
    startTableTaskPolling();
    return () => unsubscribe();
  }, [retailType]);

  // "Read" state (localStorage `islandReadIds`) is written by the navbar's Live
  // Updates panel in the same tab, which doesn't fire a `storage` event and
  // isn't otherwise observable from here — tableTasksByKey re-reads it fresh
  // on every recompute, so this tick just makes sure a recompute actually
  // happens shortly after a click there, instead of waiting for the next
  // poll tick (up to 3 minutes).
  const [readIdsVersion, setReadIdsVersion] = useState(0);
  const lastReadIdsRawRef = useRef(localStorage.getItem("islandReadIds") || "[]");
  useEffect(() => {
    if (retailType !== "RESTAURANT") return;
    const interval = setInterval(() => {
      const raw = localStorage.getItem("islandReadIds") || "[]";
      if (raw !== lastReadIdsRawRef.current) {
        lastReadIdsRawRef.current = raw;
        setReadIdsVersion((v) => v + 1);
      }
    }, 2000);
    return () => clearInterval(interval);
  }, [retailType]);

  const appConfig = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("appConfig") || "{}");
    } catch {
      return {};
    }
  }, []);
  const enabledDisplayModes = appConfig?.settings?.DISPLAY_SYSTEM_MODE?.kdsDisplayScreens || [];
  const isKDSRequired = enabledDisplayModes.includes("KDS");
  const cloudPrint = appConfig?.all?.CLOUD_PRINT?.flag === true;
  const ODS_ORDER_AUTO_BUMPING =
    appConfig?.all?.ODS_ORDER_AUTO_BUMPING?.storeConfigSettings?.orderBumpingMode;

  const tableformat = "nested";

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();
  const tableRefs = useRef({});
  const isMobileView = useGetDevice();

  // Helper to update tables in state and calculate capacity
  const applyTableData = useCallback((tables) => {
    setSelectedLayout((prevLayout) => ({
      ...prevLayout,
      children: tables,
    }));

    if (tables.length > 0) {
      const availableTables = tables.filter((t) => t?.status === "AVAILABLE").length;
      const totalTables = tables.length;
      const occupiedPercentage =
        totalTables > 0 ? Math.round(((totalTables - availableTables) / totalTables) * 100) : 0;
      setFloorCapacity(occupiedPercentage);
    }
  }, []);

  // ENHANCED: Function to fetch tables by area ID (cache-first, then background refresh)
  // cacheOnly: show cached tables only — used when fetchAllAreasInBackground will
  // fetch this area anyway, so we don't call the table/status APIs twice.
  const fetchTablesByAreaId = (areaId, skipCache = false, cacheOnly = false) => {
    if (!areaId) return;

    const cacheKey = TABLES_CACHE_PREFIX + areaId;

    // 1. Load from cache instantly (unless forced refresh)
    const cachedData = localStorage.getItem(cacheKey);
    if (!skipCache && cachedData) {
      try {
        const cachedTables = JSON.parse(cachedData);
        if (Array.isArray(cachedTables) && cachedTables.length > 0) {
          // CRITICAL: Show cached data with ALL enriched fields immediately
          applyTableData(cachedTables);
        }
      } catch {}
    }

    if (cacheOnly) return;

    // 2. Fetch fresh data (show loader only if no cache or forced refresh)
    const hasCachedData = !skipCache && cachedData;
    if (!hasCachedData) setTablesLoading(true);
    if (hasCachedData) setStatusRefreshing(true);

    const payload = { parentId: areaId };

    getAllTablesByAreaId(payload)
      .then((res) => {
        if (
          res?.data?.es > 0 ||
          res?.data?.data?.es > 0 ||
          res?.data?.status === "ERROR" ||
          res?.data?.data?.status === "ERROR"
        ) {
          showSnackbar(res?.data?.message || "Unable to fetch tables", "error");
          setTablesLoading(false);
          setStatusRefreshing(false);
          return;
        }

        const tables = res?.data || [];

        const hasOccupied = tables.some((t) => t?.status === "OCCUPIED");

        if (!hasOccupied) {
          // No occupied tables — safe to render immediately (no pink possible).
          // Apply fresh table structure with cleared status fields.
          setSelectedLayout((prevLayout) => {
            const cleanTables = tables.map((t) => ({
              ...t,
              cartStatus: null,
              statusCartId: null,
              statusOrderId: null,
              totalCartValue: 0,
              kitchenCount: 0,
            }));
            const occupiedPercentage = 0;
            setFloorCapacity(occupiedPercentage);
            return { ...prevLayout, children: cleanTables };
          });
          setTablesLoading(false);
          setStatusRefreshing(false);
          // Still call fetchTableStatuses to persist clean cache and clear refreshing state
          fetchTableStatuses(tables, false);
        } else {
          // Has occupied tables — skip the intermediate render entirely.
          // fetchTableStatuses will merge API #2 structure + API #3 enrichment in one
          // atomic state update so tables never flash pink.
          const keepLoading = !hasCachedData; // cold load: keep spinner; cached: already showing cache
          fetchTableStatuses(tables, keepLoading);
        }
      })
      .catch((err) => {
        showSnackbar("Error fetching tables", "error");
        setTablesLoading(false);
        setStatusRefreshing(false);
      });
  };

  // Helper: calculate time difference from createdDate to now
  const calculateTimeDifference = (createdDateStr) => {
    if (!createdDateStr) return null;
    // Ensure string is treated as UTC by appending 'Z' if missing
    let isoStr = createdDateStr.replace(" ", "T");
    if (!isoStr.endsWith("Z")) {
      isoStr += "Z";
    }
    const createdDate = new Date(isoStr);
    if (isNaN(createdDate.getTime())) return null;

    const now = new Date();
    const diffMs = now - createdDate;
    if (diffMs < 0) return "0m";

    const diffMins = Math.floor(diffMs / 60000);
    if (diffMins < 60) return `${diffMins}m`;

    const diffHours = Math.floor(diffMins / 60);
    const remainingMins = diffMins % 60;

    if (diffHours < 24) {
      return `${diffHours}h ${remainingMins}m`;
    }

    const diffDays = Math.floor(diffHours / 24);
    const remainingHours = diffHours % 24;
    return `${diffDays}d ${remainingHours}h ${remainingMins}m`;
  };

  // Helper: build final table list from fresh API #2 `tables` + API #3 `statusData`,
  // falling back to `prevChildren` cached enrichment for any occupied table that has
  // no entry in statusData.
  const buildEnrichedTables = useCallback((tables, statusData, prevChildren) => {
    return tables.map((table) => {
      if (table?.status === "AVAILABLE") {
        return {
          ...table,
          cartStatus: null,
          statusCartId: null,
          statusOrderId: null,
          totalCartValue: 0,
          kitchenCount: 0,
          kitchenJobs: [],
          productStatuses: [],
        };
      }

      if (table?.status === "OCCUPIED") {
        const tableMetaId = `${table?.metadata?.tableMetadataId}`;
        const statusInfo = Array.isArray(statusData)
          ? statusData.find((s) => s.tableId === tableMetaId)
          : null;

        if (statusInfo) {
          if (statusInfo.cartStatus === "CLOSED") {
            return {
              ...table,
              status: "AVAILABLE",
              cartStatus: null,
              statusCartId: null,
              statusOrderId: null,
              totalCartValue: 0,
              kitchenCount: 0,
              kitchenJobs: [],
              productStatuses: [],
            };
          }
          const kitchenCount =
            statusInfo.productStatuses?.find((p) => p.status === "REQUESTED_TO_KITCHEN")?.count ||
            0;
          return {
            ...table,
            cartStatus: statusInfo.cartStatus,
            statusCartId: statusInfo.cartId,
            statusOrderId: statusInfo.orderId,
            totalCartValue: statusInfo.totalCartValue,
            kitchenCount,
            createdDate: statusInfo.createdDate,
            kitchenJobs: statusInfo.jobs || [],
            productStatuses: statusInfo.productStatuses || [],
          };
        }

        // No API #3 data for this table — fall back to previously cached enrichment
        const prevTable = prevChildren?.find((t) => t?.mapId === table?.mapId);
        return {
          ...table,
          cartStatus: prevTable?.cartStatus || null,
          statusCartId: prevTable?.statusCartId || null,
          statusOrderId: prevTable?.statusOrderId || null,
          totalCartValue: prevTable?.totalCartValue || 0,
          kitchenCount: prevTable?.kitchenCount || 0,
          kitchenJobs: prevTable?.kitchenJobs || [],
          productStatuses: prevTable?.productStatuses || [],
        };
      }

      return table;
    });
  }, []);

  // Payload for getTableStatusByCart — limited to carts/jobs created today (local time)
  const buildTableStatusPayload = useCallback(
    (tableIds) => ({
      sourceLocationId: locId,
      destinationLocationId: locId,
      tableIds,
      orgId,
      createdStart: moment().startOf("day").toISOString(),
      createdEnd: moment().endOf("day").toISOString(),
      statuses: ["PENDING", "IN_PROGRESS"],
      fetchJobs: true,
    }),
    [locId, orgId]
  );

  // Fetch cart statuses for occupied tables and merge into table data atomically.
  // `tables` is the fresh API #2 data used as the base for the final state update,
  // so API #2 structure + API #3 enrichment land in a single render (no pink flash).
  const fetchTableStatuses = useCallback(
    (tables, keepLoading = false) => {
      const tableIds = tables
        .filter((t) => t?.status === "OCCUPIED")
        .map((t) => `${t?.metadata?.tableMetadataId}`);

      if (tableIds.length === 0) {
        // No occupied tables — just persist clean cache (state already updated by caller)
        setSelectedLayout((prevLayout) => {
          if (prevLayout?.mapId) {
            try {
              const cleanCacheData = tables.map((t) => ({
                ...t,
                cartStatus: null,
                statusCartId: null,
                statusOrderId: null,
                totalCartValue: 0,
                kitchenCount: 0,
              }));

              localStorage.setItem(
                TABLES_CACHE_PREFIX + prevLayout.mapId,
                JSON.stringify(cleanCacheData)
              );
            } catch (error) {}
          }
          return prevLayout;
        });
        if (keepLoading) setTablesLoading(false);
        setStatusRefreshing(false);
        return;
      }

      setStatusRefreshing(true);

      getTableStatusByCart(buildTableStatusPayload(tableIds))
        .then((res) => {
          const statusData = res?.data?.data?.data;

          setSelectedLayout((prevLayout) => {
            const prevChildren = prevLayout?.children || [];
            const updatedChildren = buildEnrichedTables(tables, statusData, prevChildren);

            const availableTables = updatedChildren.filter((t) => t?.status === "AVAILABLE").length;
            const totalTables = updatedChildren.length;
            setFloorCapacity(
              totalTables > 0
                ? Math.round(((totalTables - availableTables) / totalTables) * 100)
                : 0
            );

            if (prevLayout?.mapId) {
              try {
                localStorage.setItem(
                  TABLES_CACHE_PREFIX + prevLayout.mapId,
                  JSON.stringify(updatedChildren)
                );
              } catch (error) {}
            }

            return { ...prevLayout, children: updatedChildren };
          });

          if (keepLoading) setTablesLoading(false);
          setStatusRefreshing(false);
        })
        .catch((err) => {
          // On API #3 error, still commit the API #2 table structure (with cached fallback)
          // so the user isn't stuck on a spinner.
          if (keepLoading) {
            setSelectedLayout((prevLayout) => {
              const prevChildren = prevLayout?.children || [];
              const mergedTables = buildEnrichedTables(tables, null, prevChildren);
              const availableTables = mergedTables.filter((t) => t?.status === "AVAILABLE").length;
              const totalTables = mergedTables.length;
              setFloorCapacity(
                totalTables > 0
                  ? Math.round(((totalTables - availableTables) / totalTables) * 100)
                  : 0
              );
              return { ...prevLayout, children: mergedTables };
            });
            setTablesLoading(false);
          }
          setStatusRefreshing(false);
        });
    },
    [buildEnrichedTables, buildTableStatusPayload]
  );

  // Background-refresh tables for all areas of a floor and update allAreasLayouts
  const fetchAllAreasInBackground = useCallback(
    (floorId) => {
      const storedHierarchy = localStorage.getItem(HIERARCHY_DATA_KEY);
      if (!storedHierarchy) return;
      let hierarchy;
      try {
        hierarchy = JSON.parse(storedHierarchy);
      } catch {
        return;
      }
      const floor = hierarchy?.find((f) => f?.mapId === floorId);
      if (!floor?.children?.length) return;
      floor?.children?.forEach((area) => {
        getAllTablesByAreaId({ parentId: area?.mapId })
          .then((res) => {
            const tables = res?.data || [];
            const tableIds = tables
              .filter((t) => t?.status === "OCCUPIED")
              .map((t) => `${t?.metadata?.tableMetadataId}`);
            const applyToArea = (enriched) => {
              try {
                localStorage.setItem(TABLES_CACHE_PREFIX + area?.mapId, JSON.stringify(enriched));
              } catch {}
              setAllAreasLayouts((prev) => {
                if (!prev[area.mapId]) return prev;
                return { ...prev, [area.mapId]: { ...prev[area.mapId], children: enriched } };
              });
              // Also refresh the selected area, so it doesn't need its own fetch
              setSelectedLayout((prevLayout) => {
                if (prevLayout?.mapId !== area?.mapId) return prevLayout;
                const availableTables = enriched.filter((t) => t?.status === "AVAILABLE").length;
                const totalTables = enriched.length;
                setFloorCapacity(
                  totalTables > 0
                    ? Math.round(((totalTables - availableTables) / totalTables) * 100)
                    : 0
                );
                return { ...prevLayout, children: enriched };
              });
            };
            if (tableIds?.length === 0) {
              applyToArea(tables?.map((t) => ({ ...t, cartStatus: null, totalCartValue: 0 })));
              return;
            }
            getTableStatusByCart(buildTableStatusPayload(tableIds))
              .then((statusRes) => {
                const statusData = statusRes?.data?.data?.data;
                applyToArea(buildEnrichedTables(tables, statusData, []));
              })
              .catch(() => applyToArea(tables));
          })
          .catch(() => {});
      });
    },
    [buildEnrichedTables, buildTableStatusPayload]
  );

  // Refresh statuses for currently displayed tables
  const refreshCurrentStatuses = useCallback(() => {
    if (selectedAreaId === null) {
      if (selectedFloor?.parentValue) {
        fetchAllAreasInBackground(selectedFloor?.parentValue);
      }
    } else {
      const currentTables = selectedLayout?.children;
      if (currentTables?.length > 0) {
        fetchTableStatuses(currentTables);
      }
    }
  }, [
    fetchTableStatuses,
    selectedLayout,
    selectedAreaId,
    selectedFloor,
    fetchAllAreasInBackground,
  ]);

  const handleLayoutSelection = useCallback(
    (selectedData, { cacheOnly = false } = {}) => {
      // Store selected floor and area in localStorage
      localStorage.setItem(
        SELECTED_FLOOR_AREA_KEY,
        JSON.stringify({
          floor: {
            label: selectedData?.parentLabel,
            value: selectedData?.parentValue,
          },
          area: {
            label: selectedData?.childLabel,
            value: selectedData?.childValue,
          },
        })
      );

      // Update selectedLayout with area info
      setSelectedLayout((prev) => ({
        mapId: selectedData?.childValue,
        entityName: selectedData?.childLabel,
        children: prev?.mapId === selectedData?.childValue ? prev?.children : [],
      }));

      // Fetch tables (shows cached instantly, refreshes in background)
      const skipCache = forceRefreshRef.current;
      forceRefreshRef.current = false;
      fetchTablesByAreaId(selectedData?.childValue, skipCache, cacheOnly);
    },
    [fetchTablesByAreaId]
  );

  // Load all areas for a floor from localStorage cache (instant display)
  const loadAllAreasFromCache = useCallback((floorId) => {
    if (!floorId) return;
    const storedHierarchy = localStorage.getItem(HIERARCHY_DATA_KEY);
    if (!storedHierarchy) return;
    let hierarchy;
    try {
      hierarchy = JSON.parse(storedHierarchy);
    } catch {
      return;
    }
    const floor = hierarchy?.find((f) => f.mapId === floorId);
    if (!floor?.children?.length) return;
    const layouts = {};
    floor.children.forEach((area) => {
      const cached = localStorage.getItem(TABLES_CACHE_PREFIX + area.mapId);
      let children = [];
      if (cached) {
        try {
          children = JSON.parse(cached) || [];
        } catch {}
      }
      layouts[area.mapId] = { mapId: area.mapId, entityName: area.entityName, children };
    });
    setAllAreasLayouts(layouts);
  }, []);

  // Handle floor-only change from the dropdown
  // PosCustomDropdown (single-level) returns { parentValue, parentLabel }
  const handleFloorChange = useCallback(
    (floor) => {
      const floorId = floor?.value || floor?.parentValue;
      const floorLabel = floor?.label || floor?.parentLabel;
      if (!floorId) return;
      const floorData = multiLevelData?.find((f) => f?.levelOneId === floorId);
      const firstArea = floorData?.levelTwo?.[0];
      if (firstArea) {
        const selection = {
          parentLabel: floorLabel,
          parentValue: floorId,
          childLabel: firstArea?.label,
          childValue: firstArea?.value,
        };
        setSelectedFloor(selection);
        handleLayoutSelection(selection, { cacheOnly: true });
      }
      setSelectedAreaId(null);
      loadAllAreasFromCache(floorId);
      fetchAllAreasInBackground(floorId);
    },
    [multiLevelData, handleLayoutSelection, loadAllAreasFromCache, fetchAllAreasInBackground]
  );

  // Handle area tab click (null = All, specific areaId = single area)
  const handleAreaTabChange = useCallback(
    (areaId) => {
      if (areaId === null) {
        setSelectedAreaId(null);
        loadAllAreasFromCache(selectedFloor?.parentValue);
        fetchAllAreasInBackground(selectedFloor?.parentValue);
        return;
      }
      setSelectedAreaId(areaId);
      const floorData = multiLevelData?.find((f) => f?.levelOneId === selectedFloor?.parentValue);
      const area = floorData?.levelTwo?.find((a) => a?.value === areaId);
      if (area) {
        const selection = {
          parentLabel: selectedFloor?.parentLabel,
          parentValue: selectedFloor?.parentValue,
          childLabel: area?.label,
          childValue: area?.value,
        };
        setSelectedFloor(selection);
        handleLayoutSelection(selection);
      }
    },
    [
      selectedFloor,
      multiLevelData,
      handleLayoutSelection,
      loadAllAreasFromCache,
      fetchAllAreasInBackground,
    ]
  );

  // Process and store hierarchy data
  const processHierarchyData = (data) => {
    // Store the complete hierarchy data
    localStorage.setItem(HIERARCHY_DATA_KEY, JSON.stringify(data));
    setTableLayoutData(data);

    // Format floor plan for dropdown
    const floor = data?.map((floor) => ({
      label: floor?.entityName,
      value: floor?.mapId,
      ...(floor?.children?.length > 0 && { isMultiLevel: true }),
    }));
    setFloorPlan(floor);

    // Extract child level for dropdown
    const multiLevel = data?.map((layout) => ({
      levelOneId: layout?.mapId,
      levelTwo: layout?.children?.map((area) => ({
        label: area?.entityName,
        value: area?.mapId,
      })),
    }));
    setMultiLevelData(multiLevel);

    // Store floors in localStorage
    const floorsToStore = {};
    data?.forEach((floorItem) => {
      floorsToStore[floorItem?.mapId] = {
        mapId: floorItem?.mapId,
        entityName: floorItem?.entityName,
        isDefault: floorItem?.isDefault,
      };
    });
    localStorage.setItem(FLOORS_STORAGE_KEY, JSON.stringify(floorsToStore));

    // Store areas with their floor info in localStorage
    const areasToStore = {};
    data?.forEach((floorItem) => {
      floorItem?.children?.forEach((area) => {
        areasToStore[area?.mapId] = {
          mapId: area?.mapId,
          entityName: area?.entityName,
          floorId: floorItem?.mapId,
          floorName: floorItem?.entityName,
          isDefault: area?.isDefault,
        };
      });
    });
    localStorage.setItem(AREAS_STORAGE_KEY, JSON.stringify(areasToStore));
  };

  // Select default or stored floor/area
  const selectInitialFloorArea = (data) => {
    if (data?.length === 0) return;

    const storedSelection = JSON.parse(localStorage.getItem(SELECTED_FLOOR_AREA_KEY));

    if (storedSelection?.floor?.value && storedSelection?.area?.value) {
      // Check if stored selection still exists
      const persistedFloor = data.find((floor) => floor?.mapId === storedSelection?.floor?.value);

      const persistedArea = persistedFloor?.children?.find(
        (area) => area?.mapId === storedSelection?.area?.value
      );

      if (persistedFloor && persistedArea) {
        const restoredSelection = {
          parentLabel: persistedFloor?.entityName,
          parentValue: persistedFloor?.mapId,
          childLabel: persistedArea?.entityName,
          childValue: persistedArea?.mapId,
        };

        setSelectedFloor(restoredSelection);
        handleLayoutSelection(restoredSelection, { cacheOnly: true });
        loadAllAreasFromCache(persistedFloor?.mapId);
        fetchAllAreasInBackground(persistedFloor?.mapId);
        return;
      }
    }

    // If no previous selection or it doesn't exist, use default
    let defaultParent = data?.find((floor) => floor?.isDefault === "true") || data[0];
    let defaultChild =
      defaultParent?.children?.find((child) => child?.isDefault === "true") ||
      defaultParent?.children?.[0];

    if (defaultParent && defaultChild) {
      const defaultSelection = {
        childLabel: defaultChild?.entityName,
        childValue: defaultChild?.mapId,
        parentLabel: defaultParent?.entityName,
        parentValue: defaultParent?.mapId,
      };
      setSelectedFloor(defaultSelection);
      handleLayoutSelection(defaultSelection, { cacheOnly: true });
      loadAllAreasFromCache(defaultParent?.mapId);
      fetchAllAreasInBackground(defaultParent?.mapId);
    }
  };

  // Load hierarchy from localStorage or API
  const loadTableLayout = () => {
    setLoader(true);

    // Check if hierarchy data exists in localStorage
    const cachedHierarchy = localStorage.getItem(HIERARCHY_DATA_KEY);
    const cachedFloors = localStorage.getItem(FLOORS_STORAGE_KEY);
    const cachedAreas = localStorage.getItem(AREAS_STORAGE_KEY);

    if (cachedHierarchy && cachedFloors && cachedAreas) {
      // Use cached data
      const data = JSON.parse(cachedHierarchy);

      // Handle empty cached hierarchy data
      if (!data || (Array.isArray(data) && data.length === 0)) {
        // Clear invalid cache and fetch from API
        localStorage.removeItem(HIERARCHY_DATA_KEY);
        localStorage.removeItem(FLOORS_STORAGE_KEY);
        localStorage.removeItem(AREAS_STORAGE_KEY);
        // Continue to fetch from API below
      } else {
        processHierarchyData(data);
        selectInitialFloorArea(data);
        setLoader(false);
        return;
      }
    }

    // If not in cache, fetch from API
    getTableLayoutHierarchy(orgId, locId, layoutId, tableformat)
      .then((res) => {
        if (
          res?.data?.es > 0 ||
          res?.data?.data?.es > 0 ||
          res?.data?.status === "ERROR" ||
          res?.data?.data?.status === "ERROR"
        ) {
          showSnackbar(res?.data?.message || "Unable to Fetch tables", "error");
          setLoader(false);
          return;
        }

        const data = res?.data;

        // Handle empty hierarchy data
        if (!data || (Array.isArray(data) && data.length === 0)) {
          showSnackbar(
            "No floors or areas configured. Please configure table layout in RMS.",
            "warning"
          );
          setTableLayoutData([]);
          setFloorPlan([]);
          setMultiLevelData([]);
          setSelectedLayout({});
          setLoader(false);
          return;
        }

        processHierarchyData(data);
        selectInitialFloorArea(data);
        setLoader(false);
      })
      .catch((err) => {
        showSnackbar("Error loading table layout", "error");
        setLoader(false);
      });
  };

  // Force refresh hierarchy from API (for manual refresh button)
  const refreshTableLayout = () => {
    setLoader(true);

    return getTableLayoutHierarchy(orgId, locId, layoutId, tableformat)
      .then((res) => {
        if (
          res?.data?.es > 0 ||
          res?.data?.data?.es > 0 ||
          res?.data?.status === "ERROR" ||
          res?.data?.data?.status === "ERROR"
        ) {
          showSnackbar(res?.data?.message || "Unable to Fetch tables", "error");
          setLoader(false);
          return;
        }

        const data = res?.data;

        // Handle empty hierarchy data
        if (!data || (Array.isArray(data) && data.length === 0)) {
          showSnackbar(
            "No floors or areas configured. Please configure table layout in RMS.",
            "warning"
          );
          setTableLayoutData([]);
          setFloorPlan([]);
          setMultiLevelData([]);
          setSelectedLayout({});
          // Clear localStorage cache
          localStorage.removeItem(HIERARCHY_DATA_KEY);
          localStorage.removeItem(FLOORS_STORAGE_KEY);
          localStorage.removeItem(AREAS_STORAGE_KEY);
          setLoader(false);
          return;
        }

        processHierarchyData(data);
        forceRefreshRef.current = true;
        selectInitialFloorArea(data);
        setLoader(false);
        showSnackbar("Layout refreshed successfully", "success");
      })
      .catch((err) => {
        showSnackbar("Error loading table layout", "error");
        setLoader(false);
      });
  };

  // Call loadTableLayout on initial render
  useEffect(() => {
    dispatch(addcoupon(""));
    loadTableLayout();
    setSearchTerm("");
    localStorage.removeItem("loyaltyPoints");
    setComplimentaryMode(false);
    setmarkWholeCartComplimentary(false);
    setTableLayoutRefetch(() => refreshTableLayout);
    return () => {
      setTableLayoutRefetch(null);
      // Cancel any pending status-refresh timer so it doesn't fire API calls
      // after the user has already navigated away to the cart page.
      if (pendingRefreshTimerRef.current) {
        clearTimeout(pendingRefreshTimerRef.current);
      }
    };
  }, []);

  // ENHANCED: handleTableBooking - updates cache immediately
  const handleTableBooking = (tableData) => {
    setTableSelectionLoader((prev) => ({
      ...prev,
      [tableData?.mapId]: false,
    }));

    // Set selectedTable so the cart page knows which table is active without
    // needing to call dataRetriveWhenPageRefresh on mount.
    const tableDataToStore = {
      ...tableData,
      layoutName: selectedLayout?.entityName,
      tableNoForDisplay: tableData?.metadata?.tableName,
    };
    setSelectedTable(tableDataToStore);
    localStorage.setItem("selectedTableData", JSON.stringify(tableDataToStore));

    // Update the table status in selectedLayout
    setSelectedLayout((prevLayout) => {
      if (!prevLayout?.children) return prevLayout;

      const updatedChildren = prevLayout.children.map((child) => {
        if (child?.mapId === tableData?.mapId) {
          // Mark as OCCUPIED with minimal status (will be enriched by next status fetch)
          return {
            ...child,
            status: "OCCUPIED",
            cartStatus: "CREATED", // Newly occupied
            statusCartId: null, // Will be set by next refresh
            statusOrderId: null,
            totalCartValue: 0,
            kitchenCount: 0,
          };
        }
        return child;
      });

      // Update the cached tables in localStorage
      if (prevLayout?.mapId) {
        try {
          const cacheKey = TABLES_CACHE_PREFIX + prevLayout.mapId;
          localStorage.setItem(cacheKey, JSON.stringify(updatedChildren));
        } catch (error) {}
      }

      return {
        ...prevLayout,
        children: updatedChildren,
      };
    });

    // Trigger a status refresh to get the latest cart info.
    // Store the timeout so the cleanup effect can cancel it if the user
    // has already navigated away before the 1 s delay fires.
    const refreshTimer = setTimeout(() => {
      refreshCurrentStatuses();
    }, 1000);
    pendingRefreshTimerRef.current = refreshTimer;

    handleThisClose();
  };

  const cartCreateFun = (
    source,
    tableData,
    layoutName,
    cartId,
    overrideSaleMode = null,
    customerData = null
  ) => {
    if (customerData?.slotDetails) {
      localStorage.setItem("slotDetails", JSON.stringify(customerData.slotDetails));
    } else {
      localStorage.removeItem("slotDetails");
    }

    const currentSaleMode = overrideSaleMode || saleMode;
    setComments("");

    const formattedDate = new Date().toISOString().split("T")[0];

    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const formattedTime = `${hours}:${minutes}:${seconds}`;

    const [h, m, s] = formattedTime.split(":").map(Number);
    const date = new Date();
    date.setHours(h, m, s);
    date.setHours(date.getHours() + 1);

    const endTime = `${String(date.getHours()).padStart(2, "0")}:${String(
      date.getMinutes()
    ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;

    // Set subOrderType to QSR_DINE_IN for QSR branch with DINE_IN sale mode
    const subOrderType =
      branchSubType === "QSR" && currentSaleMode === "DINE_IN" ? "QSR_DINE_IN" : currentSaleMode;

    let bookingDateValue = formattedDate;
    let startTimeValue = formattedTime;
    let endTimeValue = endTime;

    if (customerData?.slotDetails) {
      const slot = customerData?.slotDetails;
      if (slot?.startTime) {
        bookingDateValue = moment(slot?.startTime).format("YYYY-MM-DD");
        startTimeValue = moment(slot?.startTime).format("HH:mm:ss");
      }
      if (slot.endTime) {
        endTimeValue = moment(slot?.endTime).format("HH:mm:ss");
      }
    }

    const executeCartCreation = (userIdVal = null, addressIdToUse = null) => {
      let restaurantPayload = {
        userName: customerData?.name || null,
        userId: userIdVal,
        mobileNo: customerData?.phone || null,
        enableWhatsapp: true,
        createdBy: retailUserLocalStorageData?.uidx,
        createdByName: retailUserLocalStorageData?.firstName,
        updatedBy: retailUserLocalStorageData?.uidx,
        updatedByName: retailUserLocalStorageData?.firstName,
        locationId: locId || "",
        sourceId: orgId || "",
        licenseId: licenseId || null,
        terminalName: licenseName || null,
        orderType: "RESTAURANT_ORDER",
        subOrderType: subOrderType,
        sourceLocationId: locId || "",
        sourceType: "RETAIL",
        channel: "POS",
        loggedInUser: retailUserLocalStorageData?.uidx,
        sourceApp: "PALLET_POS",
        destinationId: orgId || "",
        destinationLocationId: locId || "",
        destinationType: "RETAIL",
        sessionId: sessionId || null,
        bookingDate: bookingDateValue,
        startTime: startTimeValue,
        endTime: endTimeValue,
        totalMembers: tableData?.metadata?.capacity,
        bookingSource: "WALK_IN",
        ...(customerData?.slotDetails?.slotId && { slotId: customerData?.slotDetails?.slotId }),
        ...(customerData?.slotDetails?.cutoffId && {
          cutoffId: customerData?.slotDetails?.cutoffId,
        }),
      };

      if (source === "createCartFromTable") {
        restaurantPayload.cartId = cartId;
        restaurantPayload.tableNumber = tableData?.metadata?.tableName || "1";
        restaurantPayload.layoutId = selectedLayout?.mapId;
        restaurantPayload.tableId = `${tableData?.metadata?.tableMetadataId}` || "1";
        restaurantPayload.layoutName = layoutName;
      }

      if (source === "handleNextClick") {
        restaurantPayload.cartId = null;
        restaurantPayload.tableNumber = "1";
        restaurantPayload.tableId = currentSaleMode === "DELIVERY" ? "DELIVERY" : "TAKEAWAY";
        if (currentSaleMode === "DELIVERY" && customerData) {
          restaurantPayload.deliveryCharges = customerData?.deliveryCharges || 0;
          restaurantPayload.packingCharges = customerData?.packingCharges || 0;
        } else if (currentSaleMode === "TAKE_AWAY" && customerData) {
          restaurantPayload.packingCharges = customerData?.packingCharges || 0;
        }
      }

      if (currentSaleMode === "DELIVERY" && addressIdToUse && customerData?.address) {
        const addr = customerData?.address;
        const now = new Date().toISOString();
        const addressBlock = {
          addressId: String(addressIdToUse),
          country: addr?.country || "India",
          state: addr?.state || "",
          city: addr?.city || "",
          longitude: String(addr?.longitude || 0),
          latitude: String(addr?.latitude || 0),
          pinCode: addr?.postcode || addr?.pincode || addr?.pinCode || "",
          phoneNo: customerData?.phone || addr?.phoneNo || addr?.phoneNumber || "",
          addressLine1: addr?.line1 || addr?.addressLine1 || "",
          addressLine2: addr?.line2 || addr?.addressLine2 || "",
          type: addr?.addressType || addr?.type || "",
          addressType: addr?.addressType || addr?.type || "",
          landmark: addr?.landmark || "",
          updatedBy: retailUserLocalStorageData?.uidx || "",
          updatedOn: now,
        };
        restaurantPayload.billingAddress = addressBlock;
        restaurantPayload.shippingAddress = addressBlock;
      }

      return restaurantCreateCart(restaurantPayload)
        .then((res) => {
          if (
            res?.data?.status === "error" ||
            res?.data?.status === "ERROR" ||
            res?.data?.data?.es > 0
          ) {
            showSnackbar(
              res?.data?.message ||
                res?.data?.data?.message ||
                "Something went wrong while creating cart",
              "error"
            );
            if (source === "createCartFromTable") {
              setTableSelectionLoader((prev) => ({ ...prev, [tableData?.mapId]: false }));
            }
            return;
          }

          const _billing = res?.data?.data?.data?.billing;
          const customer_details = {
            name: res?.data?.data?.data?.userName || null,
            mobileNumber: res?.data?.data?.data?.mobileNo || null,
            uidx: res?.data?.data?.data?.userId || null,
            whatsapp: res?.data?.data?.data?.enableWhatsapp ?? false,
            ...(source === "handleNextClick" && currentSaleMode === "DELIVERY" && addressIdToUse
              ? { selectedAddressId: addressIdToUse }
              : {}),
            ...(source === "handleNextClick" &&
            (currentSaleMode === "DELIVERY" || currentSaleMode === "TAKE_AWAY")
              ? {
                  deliveryCharge: _billing?.deliveryCharges || 0,
                  packingCharge: _billing?.packingCharges || 0,
                }
              : {}),
          };

          // Creating orderMetricData
          if (!cartItems?.length) {
            const currentTime = new Date().getTime();
            dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
            dispatch(changePrevAddedTime(currentTime));

            const orderMetricData = {
              startTime: currentTime,
              prevAddedProductTime: currentTime,
              startTimeAdded: true,
              manuallyAdded: 0,
              scannedProduct: 0,
              isMultipleBatch: false,
              avgProductAddTime: "",
              totalProducts: 0,
              productTimeArray: [],
              editOrderItem: 0,
              manuallyRemovedItems: 0,
              manualItemsGtin: [],
            };
            localStorage.setItem("orderMetricData", JSON.stringify(orderMetricData));
          }

          // showSnackbar("Cart Added successfully", "success");
          setCartId(res?.data?.data?.data?.cartId);
          setCartItems(res?.data?.data?.data?.cartProducts || []);
          setCartTotalQty(res?.data?.data?.data?.billing?.quantity);
          setCgst(res?.data?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.data?.billing?.sgst);
          setCess(res?.data?.data?.data?.billing?.totalCessAmount);
          setSubTotal(res?.data?.data?.data?.billing?.totalCartValue);
          setTotal(res?.data?.data?.data?.billing?.totalCartValue);
          if (retailType === "RESTAURANT") {
            if (res?.data?.data?.data?.subOrderType === "QSR_DINE_IN") {
              setSaleMode("DINE_IN");
            } else {
              setSaleMode(res?.data?.data?.data?.subOrderType);
            }
          } else {
            setSaleMode(res?.data?.data?.data?.subOrderType);
          }
          setTotalValue(res?.data?.data?.data?.billing?.totalValue);
          setCartStatus(res?.data?.data?.data?.cartStatus);
          setPrintedBillOrderId(res?.data?.data?.data?.orderId);
          setIsBillPrinted(true);

          localStorage.setItem("CartId", res?.data?.data?.data?.cartId);
          localStorage.setItem("sessionId", sessionId);
          localStorage.setItem("licenseId", licenseId);
          localStorage.setItem("customer_details", JSON.stringify(customer_details));
          setCustomerMobileNumber(customer_details.mobileNumber);
          setCustomerName(customer_details.name);
          setCategoryName("");
          localStorage.removeItem("loyaltyDetails");
          localStorage.removeItem("loyaltyPoints");
          setComplimentaryMode(false);
          setmarkWholeCartComplimentary(false);

          const loyaltyPointData = res?.data?.data?.data?.loyaltyPoints;
          if (
            (loyaltyPointData !== null || loyaltyPointData !== undefined) &&
            Number(loyaltyPointData) > 0
          ) {
            localStorage.setItem("loyaltyPoints", loyaltyPointData);
          }

          if (typeof syncCartDiscountState === "function") {
            syncCartDiscountState(res?.data?.data?.data);
          }

          isMobilePos &&
            emit({
              type: "localData",
              data: {
                CartId: res?.data?.data?.data?.cartId,
                customer_details: customer_details,
              },
            });

          if (source === "createCartFromTable") {
            if (!isTableOccupied(tableData?.status)) {
              handleTableBooking(tableData);
            }
            if (isTableOccupied(tableData?.status)) {
              setTableSelectionLoader((prev) => ({ ...prev, [tableData?.mapId]: false }));
              const updatedTable = {
                ...tableData,
                layoutName: layoutName,
                tableNoForDisplay: tableData?.metadata?.tableName,
              };
              setSelectedTable(updatedTable);
              localStorage.setItem("selectedTableData", JSON.stringify(updatedTable));
              handleThisClose();
            }
          }

          if (source === "handleNextClick") {
            handleThisClose();
          }
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
          if (source === "createCartFromTable") {
            setTableSelectionLoader((prev) => ({ ...prev, [tableData?.mapId]: false }));
          }
          if (
            err?.response?.data?.message ===
            "Unable to fetch cart details. :: Cart is already closed please create new cart."
          ) {
            removeFromLocalStorage("CartId");
          }
        });
    };

    const handleAddressAndCartCreation = (customerIdVal) => {
      const isDeliveryMode = currentSaleMode === "DELIVERY";
      const addr = customerData?.address;

      if (isDeliveryMode && addr) {
        if (addr?.addressId) {
          return executeCartCreation(customerIdVal, addr?.addressId);
        } else {
          const addrCreatePayload = {
            customerId: customerIdVal || customerData?.id || customerData?.uidx,
            addressLine1: addr?.line1 || addr?.addressLine1 || "",
            addressLine2: addr?.line2 || addr?.addressLine2 || "",
            city: addr?.city || "",
            state: addr?.state || "",
            country: addr?.country || "India",
            pincode: addr?.postcode || addr?.pincode || addr?.pinCode || "",
            addressType: addr?.addressType || addr?.type || "",
            phoneNumber: customerData?.phone || addr?.phoneNo || addr?.phoneNumber || "",
            landmark: addr?.landmark || "",
            defaultShipping: true,
            defaultBilling: true,
            latitude: 0,
            longitude: 0,
            createdBy: retailUserLocalStorageData?.firstName || "",
            ...(addr?.addressType === "OTHER" && { otherName: addr?.otherName }),
          };
          return createAddress(addrCreatePayload)
            .then((cr) => {
              if (
                cr?.data?.status === "ERROR" ||
                cr?.data?.status === "error" ||
                cr?.data?.data?.es > 0 ||
                cr?.data?.es > 0 ||
                cr?.data?.data?.status === "ERROR" ||
                cr?.data?.data?.status === "error"
              ) {
                showSnackbar(
                  cr?.data?.data?.message || cr?.data?.message || "Unable to Add delivery address",
                  "error"
                );
                return executeCartCreation(customerIdVal, null);
              }
              const newAddrId = cr?.data?.address?.addressId;
              if (newAddrId) {
                showSnackbar("Delivery address added successfully", "success");
                return executeCartCreation(customerIdVal, newAddrId);
              } else {
                return executeCartCreation(customerIdVal, null);
              }
            })
            .catch((err) => {
              showSnackbar(
                err?.response?.data?.message || err?.message || "Unable to Add delivery address",
                "error"
              );
              return executeCartCreation(customerIdVal, null);
            });
        }
      } else {
        return executeCartCreation(customerIdVal, null);
      }
    };

    if (customerData && customerData?.phone) {
      if (customerData?.uidx) {
        // Existing customer: link to session, then create cart
        let customerUidxData = {
          uidx: customerData?.uidx,
          phoneNumber: customerData?.phone,
          name: customerData?.name,
          organizationId: orgId,
          createdBy: retailUserLocalStorageData?.uidx,
          locationId: locId,
          sessionId: sessionId,
          platform: "POS"
        };
        /*
        return AddedCustomerData(customerUidxData)
          .then((resp) => {
            const storeCustId =
              resp?.data?.retailCustomer?.id || customerData?.id || customerData?.uidx;
            localStorage.setItem("customerId", storeCustId);
            return handleAddressAndCartCreation(storeCustId);
          })
        */
        return createB2CcustomerApi(customerUidxData)
          .then((resp) => {
            const storeCustId =
              resp?.data?.customer?.id || customerData?.id || customerData?.uidx;
            localStorage.setItem("customerId", storeCustId);
            return handleAddressAndCartCreation(storeCustId);
          })
          .catch(() => {
            const storeCustId = customerData?.id || customerData?.uidx;
            localStorage.setItem("customerId", storeCustId);
            return handleAddressAndCartCreation(storeCustId);
          });
      } else {
        // New customer: create in database, link to session, then create cart
        let addCustomerPayload = {
          mobile: customerData?.phone,
          firstName: customerData?.name,
          countryCode: "91",
          tenantId: locId,
        };
        return addCustomer(addCustomerPayload)
          .then((response) => {
            const uidx = response?.data?.data?.uidx;
            if (uidx) {
              let customerUidxData = {
                uidx: uidx,
                phoneNumber: customerData?.phone,
                name: response?.data?.data?.firstName || customerData?.name,
                organizationId: orgId,
                createdBy: retailUserLocalStorageData?.uidx,
                locationId: locId,
                sessionId: sessionId,
                platform: "POS"
              };
              /*
              return AddedCustomerData(customerUidxData)
                .then((resp) => {
                  const storeCustId = resp?.data?.retailCustomer?.id || uidx;
                  localStorage.setItem("customerId", storeCustId);
                  return handleAddressAndCartCreation(storeCustId);
                })
              */
              return createB2CcustomerApi(customerUidxData)
                .then((resp) => {
                  const storeCustId = resp?.data?.customer?.id || uidx;
                  localStorage.setItem("customerId", storeCustId);
                  return handleAddressAndCartCreation(storeCustId);
                })
                .catch(() => {
                  localStorage.setItem("customerId", uidx);
                  return handleAddressAndCartCreation(uidx);
                });
            } else {
              return handleAddressAndCartCreation(null);
            }
          })
          .catch((err) => {
            showSnackbar(
              err?.response?.data?.message || err?.message || "Failed to create customer",
              "error"
            );
            return handleAddressAndCartCreation(null);
          });
      }
    } else {
      return handleAddressAndCartCreation(null);
    }
  };

  const createCartFromTable = (tableData, layoutName, cartId = null) => {
    if (cartIdFromLocal && !isTableOccupied(tableData?.status)) {
      localStorage.removeItem("CartId");
    }
    cartCreateFun("createCartFromTable", tableData, layoutName, cartId);
  };

  // Save table to "my tables" list (last 5 used)
  const addToMyTables = (mapId) => {
    try {
      const stored = JSON.parse(localStorage.getItem(MY_TABLES_KEY) || "[]");
      const filtered = stored.filter((id) => id !== mapId);
      filtered.unshift(mapId);
      localStorage.setItem(MY_TABLES_KEY, JSON.stringify(filtered.slice(0, 5)));
    } catch {
      localStorage.setItem(MY_TABLES_KEY, JSON.stringify([mapId]));
    }
  };

  /* Handling table selection */
  const handleTableSelection = (tableData, layoutName) => {
    if (saleMode !== "DINE_IN") {
      showSnackbar(`Please change sale mode to 'Dine in' to select a table`, "warning");
      return;
    }

    addToMyTables(tableData?.mapId);

    localStorage.setItem(
      LAST_SELECTED_TABLE_KEY,
      JSON.stringify({
        tableMapId: tableData?.mapId,
        layoutId: selectedLayout?.mapId,
      })
    );

    if (isTableOccupied(tableData?.status)) {
      setTableSelectionLoader((prev) => ({ ...prev, [tableData?.mapId]: true }));
      if (cartIdFromLocal) {
        localStorage.removeItem("CartId");
      }
      createCartFromTable(tableData, layoutName, tableData?.statusCartId || null);
      return;
    }

    setPendingTableData(tableData);
    setPendingLayoutName(layoutName);
    setTableConfirmationModalOpen(true);
  };

  const handleThisClose = useCallback(() => {
    setSearchTerm("");
    navigate("/restaurant/cart");
  }, [navigate]);

  const handleBottomButtonClick = useCallback(
    (button) => {
      if (button === "orders") {
        navigate("/products/orderstable");
        return;
      }

      if (button === "inventory") {
        navigate("/products/inventory");
        return;
      }

      if (button === "ods") {
        if (!enabledDisplayModes.find((mode) => mode === "ODS")) {
          showSnackbar("ODS is disabled from configuration", "warning");
          return;
        }
        navigate("/orders");
        return;
      }

      if (button === "returns") {
        navigate("/returns");
      }

      if (button === "sessions") {
        navigate("/session-page/session-listing");
        return;
      }

      if (button === "tableOrdering") {
        navigate("/products/table-ordering");
        return;
      }

      if (button === "kds") {
        if (!enabledDisplayModes.find((mode) => mode === "KDS")) {
          showSnackbar("KDS is disabled from the configuration", "warning");
          return;
        }
        navigate("/products/kitchen-display");
        return;
      }

      if (button === "settings") {
        navigate("/settings");
        return;
      }

      if (button === "sessions") {
        navigate("/session-page/session-listing");
        return;
      }

      if (button === "menu") {
        setMenuAvailabilityOpen(true);
        return;
      }

      showSnackbar("Feature is coming soon", "warning");
      return;
    },
    [enabledDisplayModes, isKDSRequired, navigate, setMenuAvailabilityOpen, showSnackbar]
  );

  const handleNextClick = useCallback(
    (overrideSaleMode = null, customerData = null) => {
      if (cartIdFromLocal) {
        localStorage.removeItem("CartId");
        setCartId("");
      }
      return cartCreateFun("handleNextClick", "", "", "", overrideSaleMode, customerData);
    },
    [cartCreateFun, cartIdFromLocal, setCartId]
  );

  const handleShowOrderModal = useCallback((mode) => {
    setPendingOrderMode(mode);
    setOrderDetailsModalOpen(true);
  }, []);

  const waitForPrintableOrder = useCallback(
    async (targetOrderId, maxAttempts = 4) => {
      if (!targetOrderId) return null;

      for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
        try {
          const orderDetailsRes = await getOrderDetails(targetOrderId, locId);
          const printableOrderId = orderDetailsRes?.data?.data?.baseOrderResponse?.orderId;

          if (printableOrderId) {
            return printableOrderId;
          }
        } catch (error) {}

        if (attempt < maxAttempts - 1) {
          await new Promise((resolve) => setTimeout(resolve, 500 * (attempt + 1)));
        }
      }

      return null;
    },
    [locId]
  );

  // Print bill directly from table layout for occupied tables
  const handleTablePrintBill = async (tableData) => {
    const mapId = tableData?.mapId;
    const printerConfig = JSON.parse(localStorage.getItem("printerConfig") || "null");

    if (!printerConfig) {
      showSnackbar("Please configure printer from Settings > Peripherals", "warning");
      return;
    }

    setTableActionLoader((prev) => ({ ...prev, [mapId]: "print" }));

    try {
      // Case 1: ORDER_CREATED — orderId already available from status API
      if (tableData?.statusOrderId) {
        const printableOrderId = await waitForPrintableOrder(tableData.statusOrderId);

        if (!printableOrderId) {
          showSnackbar("Bill is not ready to print yet", "error");
          setTableActionLoader((prev) => ({ ...prev, [mapId]: null }));
          return;
        }

        startPrint({
          orderId: printableOrderId,
          reprint: false,
          onPrintComplete: () => {
            setTableActionLoader((prev) => ({ ...prev, [mapId]: null }));
            showSnackbar("Bill printed successfully", "success");
            refreshCurrentStatuses();
          },
          onPrintError: () => {
            setTableActionLoader((prev) => ({ ...prev, [mapId]: null }));
            showSnackbar("Failed to print bill", "error");
          },
        });
        return;
      }

      // Case 2: ORDER_PLACED — need to call CreateRestaurantOrder to get orderId
      const cartId = tableData?.statusCartId;
      if (!cartId) {
        showSnackbar("No cart found for this table", "error");
        setTableActionLoader((prev) => ({ ...prev, [mapId]: null }));
        return;
      }

      const billPayload = {
        sessionId: sessionId,
        licenseId: licenseId,
        cartId: cartId,
        paymentType: "SPLIT",
        paymentMethod: "CASH",
        paymentMode: "OFFLINE",
        inventoryCheck: "NO",
        amount: 0,
        tender: 0,
        balance: tableData?.totalCartValue || 0,
        orderedBy: retailUserLocalStorageData?.uidx,
        orderedByName: retailUserLocalStorageData?.firstName,
        ...(ODS_ORDER_AUTO_BUMPING === "AUTO" ? { autoAccept: true } : { autoAccept: false }),
      };

      const orderRes = await CreateRestaurantOrder(billPayload);
      const orderId = orderRes?.data?.data?.orderResponseModel?.orderId;

      // Refresh statuses since order creation changes cart status
      refreshCurrentStatuses();

      if (!orderId) {
        showSnackbar("Failed to create order for printing", "error");
        setTableActionLoader((prev) => ({ ...prev, [mapId]: null }));
        return;
      }

      const printableOrderId = await waitForPrintableOrder(orderId);

      if (!printableOrderId) {
        showSnackbar("Bill is not ready to print yet", "error");
        setTableActionLoader((prev) => ({ ...prev, [mapId]: null }));
        return;
      }

      startPrint({
        orderId: printableOrderId,
        reprint: false,
        onPrintComplete: () => {
          setTableActionLoader((prev) => ({ ...prev, [mapId]: null }));
          showSnackbar("Bill printed successfully", "success");
          refreshCurrentStatuses();
        },
        onPrintError: () => {
          setTableActionLoader((prev) => ({ ...prev, [mapId]: null }));
          showSnackbar("Failed to print bill", "error");
        },
      });
    } catch (err) {
      showSnackbar(err?.response?.data?.message || "Error printing bill", "error");
      setTableActionLoader((prev) => ({ ...prev, [mapId]: null }));
    }
  };

  // Record payment: load cart data and open RestaurantPaymentModal inline over the
  // table grid, so the operator never loses sight of the layout they are working in.
  const handleTableRecordPayment = (tableData) => {
    const mapId = tableData?.mapId;

    // Save last selected table so it blinks after payment completes
    localStorage.setItem(
      LAST_SELECTED_TABLE_KEY,
      JSON.stringify({
        tableMapId: mapId,
        layoutId: selectedLayout?.mapId,
      })
    );
    setLastSelectedTableId(mapId);

    // Immediate visual feedback — button grays out exactly like the print button so
    // the operator always sees their tap/click registered.
    setTableActionLoader((prev) => ({ ...prev, [mapId]: "payment" }));

    setPaymentTableData(tableData);
    setTpPaymentMethod("CASH");
    setTpEnterAmount("");
    setTpPaymentLoader(false);
    setTpPaymentSuccess(false);
    setTpPaymentFailed(false);
    setTpPaymentCancel(false);
    setTpSplitActive(false);
    setTpPartialStatus(false);
    setTpAmountPaid("");
    setTpAmountDue("");
    setTpCashChange(false);
    setTpNewLoader(false);
    setTpModalLoader(false);
    setTpPayLoader(false);
    setTpManual(false);
    setTpCancelLoader(false);
    setTpNewId(tableData?.statusOrderId || null);
    setTpOrderSummary(null);

    const cartId = tableData?.statusCartId;
    const orderId = tableData?.statusOrderId;

    // The modal reads the cart through CartId, so it must be in place before it opens.
    const openModal = (resolvedCartId) => {
      if (resolvedCartId) {
        localStorage.setItem("CartId", resolvedCartId);
      }
      setTableActionLoader((prev) => ({ ...prev, [mapId]: null }));
      setPaymentModalOpen(true);
    };

    if (orderId) {
      // ORDER_CREATED / PAYMENT_PENDING tables: read the live payment status so the
      // modal opens on the outstanding amount rather than the full cart value.
      // The quick-status API sometimes omits cartId while orderId is present, so the
      // cartId is resolved from order details here too.
      getOrderDetails(orderId, locId)
        .then((res) => {
          const orderData = res?.data?.data?.baseOrderResponse;
          const resolvedCartId = cartId || orderData?.cartId || null;

          if (orderData) {
            const amountPaid = orderData?.amountPaid || 0;
            const outstandingAmount = orderData?.outstandingAmount || 0;

            // amountPaid=0 → Unpaid, both > 0 → Partially Paid, nothing left → Completed
            let displayStatus = "UNPAID";
            if (amountPaid > 0 && outstandingAmount > 0) {
              displayStatus = "PARTIALLY_PAID";
            } else if (outstandingAmount === 0 && amountPaid > 0) {
              displayStatus = "COMPLETED";
            }

            setTpOrderSummary({
              itemCount: orderData?.numberOfLineItems || 0,
              orderValue: outstandingAmount + amountPaid,
              displayStatus,
              amountPaid,
              outstandingAmount,
            });

            // Total is the outstanding amount — what remains to be paid
            setTpTotal(outstandingAmount);
            setTpCartItems(
              orderData?.orderItemList?.length > 0
                ? orderData.orderItemList
                : [{ id: "placeholder" }]
            );
            setTpNewId(orderData?.orderId);
          }

          if (!resolvedCartId) {
            setTableActionLoader((prev) => ({ ...prev, [mapId]: null }));
            showSnackbar("No cart found for this table", "error");
            return;
          }
          openModal(resolvedCartId);
        })
        .catch(() => {
          // Fallback to cart data
          setTpOrderSummary(null);
          if (!cartId) {
            setTableActionLoader((prev) => ({ ...prev, [mapId]: null }));
            showSnackbar("No cart found for this table", "error");
            return;
          }
          loadCartDataFallback(cartId, tableData, openModal);
        });
      return;
    }

    if (!cartId) {
      // No cart, no order — table card should not have shown the payment button.
      setTableActionLoader((prev) => ({ ...prev, [mapId]: null }));
      showSnackbar("No cart found for this table", "error");
      return;
    }

    // ORDER_PLACED — no order yet, load cart data
    loadCartDataFallback(cartId, tableData, openModal);
  };

  const loadCartDataFallback = (cartId, tableData, openModal) => {
    dataRetriveWhenPageRefresh(cartId)
      .then((res) => {
        const data = res?.data?.data?.data;
        if (data?.cartProducts?.length > 0) {
          setTpCartItems(data?.cartProducts);
          setTpTotal(data?.billing?.totalCartValue);
        } else {
          setTpCartItems([{ id: "placeholder" }]);
          setTpTotal(tableData?.totalCartValue || 0);
        }
        openModal(cartId);
      })
      .catch(() => {
        setTpCartItems([{ id: "placeholder" }]);
        setTpTotal(tableData?.totalCartValue || 0);
        openModal(cartId);
      });
  };

  const closeTablePaymentModal = () => {
    setPaymentModalOpen(false);
    setPaymentTableData(null);
    setTpCartItems([]);
    setTpTotal(0);
    setTpPaymentMethod("CASH");
    setTpEnterAmount("");
    setTpSplitActive(false);
    setTpPartialStatus(false);
    setTpPaymentLoader(false);
    setTpPaymentSuccess(false);
    setTpPaymentFailed(false);
    setTpNewId(null);
    setTpCashChange(false);
    setTpAmountPaid("");
    setTpAmountDue("");
    setTpOrderSummary(null);
    setTpPayLoader(false);
    refreshTableLayout();
  };

  // ENHANCED: tpResetValues - updates local state and cache immediately
  const tpResetValues = () => {
    // Close cart first
    const cartId = paymentTableData?.statusCartId;
    if (cartId) {
      const payload = {
        cartId: cartId,
        closedBy: retailUserLocalStorageData?.uidx,
        closedByName: retailUserLocalStorageData?.firstName,
        comments: "Cart closed",
      };
      restaurantCartClose(payload)
        .then(() => {
          // Update local state immediately for instant feedback
          setSelectedLayout((prevLayout) => {
            if (!prevLayout?.children) return prevLayout;

            const updatedChildren = prevLayout.children.map((table) => {
              if (table?.statusCartId === cartId) {
                return {
                  ...table,
                  status: "AVAILABLE",
                  cartStatus: null,
                  statusCartId: null,
                  statusOrderId: null,
                  totalCartValue: 0,
                  kitchenCount: 0,
                };
              }
              return table;
            });

            // Update cache immediately
            if (prevLayout?.mapId) {
              try {
                localStorage.setItem(
                  TABLES_CACHE_PREFIX + prevLayout.mapId,
                  JSON.stringify(updatedChildren)
                );
              } catch {}
            }

            return { ...prevLayout, children: updatedChildren };
          });

          // Update allAreasLayouts immediately for instant feedback in All-areas mode
          setAllAreasLayouts((prevLayouts) => {
            const updatedLayouts = { ...prevLayouts };
            Object.keys(updatedLayouts).forEach((areaId) => {
              const area = updatedLayouts[areaId];
              if (area?.children) {
                const updatedChildren = area?.children?.map((table) => {
                  if (table?.statusCartId === cartId) {
                    return {
                      ...table,
                      status: "AVAILABLE",
                      cartStatus: null,
                      statusCartId: null,
                      statusOrderId: null,
                      totalCartValue: 0,
                      kitchenCount: 0,
                    };
                  }
                  return table;
                });

                // Update cached tables in localStorage for this area
                try {
                  localStorage.setItem(
                    TABLES_CACHE_PREFIX + areaId,
                    JSON.stringify(updatedChildren)
                  );
                } catch {}

                updatedLayouts[areaId] = { ...area, children: updatedChildren };
              }
            });
            return updatedLayouts;
          });

          // Then refresh from server to confirm
          setTimeout(() => {
            refreshCurrentStatuses();
          }, 500);
        })
        .catch(() => {
          // Even on error, try to refresh
          refreshCurrentStatuses();
        });
    } else {
      refreshCurrentStatuses();
    }

    // Reset payment modal states
    setTpCartItems([]);
    setTpTotal(0);
    setTpSplitActive(false);
    setTpPartialStatus(false);
    setTpEnterAmount("");
    setTpAmountPaid("");
    setTpAmountDue("");
    setTpPayLoader(false);
    setTpCashChange(false);
    setTpNewId(null);
    setTpPaymentLoader(false);
  };

  const tpHandleSplitPayment = () => {
    setTpPaymentMethod("CASH");
    setTpSplitActive(true);
    setTpEnterAmount("");
  };

  // Poll order status to get amount due (mirrors Cart.js callGetOrder)
  const tpCallGetOrder = (orderId, currentRetry) => {
    setTpPaymentSuccess(false);
    const maxRetries = 95;
    let retry = currentRetry || 0;
    orderStatusRetry(orderId)
      .then((res) => {
        const orderData = res?.data?.data?.baseOrderResponse;
        if (
          orderData?.paymentStatus === "PAYMENT_PENDING" &&
          retry < maxRetries &&
          orderData?.orderStatus === "CREATED"
        ) {
          retry++;
          setTpPartialStatus(true);
          showSnackbar(orderData?.paymentStatus, "success");
          setTimeout(() => tpCallGetOrder(orderId, retry), 2000 + retry);
        } else if (
          orderData?.paymentStatus === "PAYMENT_CANCELLED" ||
          orderData?.paymentStatus === "CANCELLED"
        ) {
          setTpPaymentLoader(false);
          return;
        } else if (orderData?.paymentStatus === "PARTIALLY_PAID") {
          showSnackbar(orderData?.paymentStatus, "success");
          setTpAmountPaid(orderData?.amountPaid);
          setTpAmountDue(orderData?.outstandingAmount);
          setTpPartialStatus(true);
          setTpCashChange(true);
          setTpEnterAmount("");
          // Update order summary with current payment state
          setTpOrderSummary((prev) => ({
            ...(prev || {}),
            amountPaid: orderData?.amountPaid,
            outstandingAmount: orderData?.outstandingAmount,
            displayStatus: "PARTIALLY_PAID",
          }));
          if (tpSplitActive) {
            setTpPaymentSuccess(false);
            setTpPaymentLoader(false);
          }
        } else if (orderData?.paymentStatus === "COMPLETED") {
          setTpPaymentSuccess(true);
          setTpPaymentLoader(true);
          showSnackbar("Payment Success", "success");
          // Update order summary to paid
          setTpOrderSummary((prev) => ({
            ...(prev || {}),
            amountPaid: orderData?.amountPaid || prev?.orderValue,
            outstandingAmount: 0,
            displayStatus: "COMPLETED",
          }));
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
      });
  };

  const tpHandleSplitInputChange = (e) => {
    setTpEnterAmount(e.target.value);
  };

  // checkPayment for table payment - routes based on cart status
  const tpCheckPayment = async () => {
    const tableData = paymentTableData;
    if (!tableData) return;

    const machineId = localStorage.getItem("machineId");
    const roundedTotal = Math.round(tpTotal);
    // Complimentary / fully-discounted orders have nothing due — mirror Cart.js's
    // isZeroOrder bypass so the CASH amount checks below don't block them.
    const isZeroOrder = roundedTotal <= 0;
    const roundedEnterAmount = isZeroOrder ? 0 : Math.round(Number(tpEnterAmount) || 0);

    // ORDER_CREATED: orderId already exists, go to payOrderSplit
    if (tableData?.cartStatus === "ORDER_CREATED" && (tpNewId || tableData?.statusOrderId)) {
      const targetOrderId = tpNewId || tableData?.statusOrderId;
      setTpNewId(targetOrderId);
      await tpPartialCompletePayment(targetOrderId);
      return;
    }

    // ORDER_PLACED: need to create order first via CreateRestaurantOrder
    const cartId = tableData?.statusCartId;
    if (!cartId) {
      showSnackbar("No cart found for this table", "error");
      return;
    }

    // Validate CASH amount
    if (!isZeroOrder && tpPaymentMethod === "CASH" && (!tpEnterAmount || roundedEnterAmount <= 0)) {
      showSnackbar("Please enter amount to proceed", "error");
      return;
    }

    if (
      !isZeroOrder &&
      tpPaymentMethod === "CASH" &&
      !tpSplitActive &&
      roundedEnterAmount > 0 &&
      roundedEnterAmount < roundedTotal
    ) {
      showSnackbar("Less amount cannot be added", "error");
      return;
    }

    setTpNewLoader(true);

    const change = (roundedEnterAmount - roundedTotal).toFixed(2);

    const createPayload = {
      sessionId: sessionId,
      licenseId: licenseId,
      ...(tpSplitActive && { paymentType: "SPLIT" }),
      licenseName: licenseName,
      machineCode: machineId || "CASH",
      cartId: cartId,
      paymentMode: !machineId ? "OFFLINE" : "ONLINE",
      paymentMethod: tpPaymentMethod,
      inventoryCheck: "NO",
      tender: roundedEnterAmount,
      balance: String(Math.abs(change)),
      amount: tpSplitActive ? roundedEnterAmount : roundedTotal,
      orderedBy: retailUserLocalStorageData?.uidx,
      orderedByName: retailUserLocalStorageData?.firstName,
    };

    try {
      const res = await CreateRestaurantOrder(createPayload);

      if (res?.data?.data?.es) {
        showSnackbar(res?.data?.data?.message || "Something went wrong", "error");
        setTpNewLoader(false);
        return;
      }

      const orderId = res?.data?.data?.orderResponseModel?.orderId;
      setTpNewId(orderId);

      if (tpSplitActive) {
        setTpNewLoader(false);
        // Initialize order summary if not already set (ORDER_PLACED first payment)
        if (!tpOrderSummary) {
          setTpOrderSummary({
            itemCount: tpCartItems?.length || 0,
            orderValue: roundedTotal,
            displayStatus: "UNPAID",
            amountPaid: 0,
            outstandingAmount: roundedTotal,
          });
        }
        tpCallGetOrder(orderId);
      } else {
        setTpNewLoader(false);
        setTpPaymentLoader(true);
        setTpPaymentSuccess(true);
        if (tpPaymentMethod === "CASH") openDrawer();
        showSnackbar("Payment Success", "success");
      }
    } catch (err) {
      showSnackbar(err?.response?.data?.message || "Payment failed", "error");
      setTpNewLoader(false);
    }
  };

  // partialCompletePayment for table payment - calls payOrderSplit
  const tpPartialCompletePayment = async (overrideOrderId) => {
    const targetOrderId = overrideOrderId || tpNewId;
    if (!targetOrderId) {
      showSnackbar("No order found for this table", "error");
      return;
    }

    const machineId = localStorage.getItem("machineId");
    const roundedTotal = Math.round(tpTotal);
    const roundedEnterAmount = Math.round(Number(tpEnterAmount) || 0);

    if ((roundedEnterAmount === "" || roundedEnterAmount < 0) && tpPaymentMethod === "CASH") {
      showSnackbar("Please enter a valid amount", "error");
      return;
    }

    if (
      tpPaymentMethod === "CASH" &&
      !tpSplitActive &&
      roundedEnterAmount > 0 &&
      roundedEnterAmount < (Number(tpAmountDue) || roundedTotal)
    ) {
      showSnackbar("Less amount cannot be added", "error");
      return;
    }

    if (
      (roundedEnterAmount === 0 || roundedEnterAmount === "" || roundedEnterAmount < 1) &&
      tpSplitActive
    ) {
      showSnackbar("You need to pay atleast 1 Rupee to process this order", "error");
      return;
    }

    setTpCancelLoader(false);
    setTpPayLoader(true);
    const change = (roundedEnterAmount - (Number(tpAmountDue) || roundedTotal)).toFixed(2);

    const payload = {
      orderId: targetOrderId,
      ...(tpSplitActive && { paymentType: "SPLIT" }),
      amount: tpSplitActive || tpPaymentMethod === "CASH" ? roundedEnterAmount : roundedTotal,
      paymentMethod: tpPaymentMethod,
      paymentMode: !machineId ? "OFFLINE" : "ONLINE",
      licenseId: licenseId,
      sessionId: sessionId,
      loggedInUserId: retailUserLocalStorageData?.uidx,
      machineCode: machineId,
      tender: roundedEnterAmount,
      balance: String(Math.abs(change)),
    };

    try {
      const res = await payOrderSplit(payload);

      if (res?.data?.data?.es === 1) {
        showSnackbar(res?.data?.data?.message, "error");
        return;
      }

      if (res?.data?.data?.paymentStatus === "COMPLETED") {
        setTpPaymentSuccess(true);
        setTpPaymentLoader(true);
        showSnackbar("Payment Success", "success");
      } else if (
        res?.data?.data?.paymentStatus === "PARTIALLY_PAID" ||
        res?.data?.data?.paymentStatus === "PAYMENT_PENDING" ||
        res?.data?.data?.paymentStatus === "PAYMENT_CANCELLED"
      ) {
        // Set immediate state from response (same as Cart.js partialCompletePayment)
        setTpCashChange(true);
        showSnackbar(res?.data?.data?.orderStatus, "success");
        setTpEnterAmount("");
        setTpAmountPaid(res?.data?.data?.amountPaid);
        setTpAmountDue(res?.data?.data?.amountToBePaid);
        setTpPayLoader(false);
        // Poll order status for accurate amounts
        tpCallGetOrder(targetOrderId);
      }
    } catch (err) {
      setTpPayLoader(false);
      showSnackbar(err?.response?.data?.message || "Payment failed", "error");
    }
  };

  useEffect(() => {
    if (!searchTerm) return;

    const lowerSearch = searchTerm?.toLowerCase();

    const matchingTable = selectedLayout?.children?.find(
      (table) =>
        table?.metadata?.tableName?.toLowerCase().includes(lowerSearch) &&
        table?.status !== "BLOCKED"
    );

    if (matchingTable) {
      tableRefs.current[matchingTable.mapId]?.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  }, [searchTerm, selectedLayout]);

  const filteredTables = useMemo(() => {
    if (!selectedLayout?.children) return [];

    let myTableIds = [];
    if (activeChip === "MY_TABLES") {
      try {
        myTableIds = JSON.parse(localStorage.getItem(MY_TABLES_KEY) || "[]");
      } catch {
        myTableIds = [];
      }
    }

    return selectedLayout?.children
      .filter((t) => t?.status !== "BLOCKED")
      .filter((t) => {
        if (activeChip === "MY_TABLES") return myTableIds.includes(t?.mapId);
        if (activeChip === "AVAILABLE") return t?.status === "AVAILABLE";
        if (activeChip === "OCCUPIED")
          return (
            t?.status === "OCCUPIED" &&
            t?.cartStatus !== "ORDER_CREATED" &&
            t?.cartStatus !== "PAYMENT_PENDING"
          );
        if (activeChip === "ORDER_CREATED") return t?.cartStatus === "ORDER_CREATED";
        return true;
      })
      .filter((t) =>
        searchTerm
          ? t?.metadata?.tableName?.toLowerCase().includes(searchTerm?.toLowerCase())
          : true
      );
  }, [selectedLayout, activeChip, searchTerm]);

  // Reset focused table index when filter or search changes
  useEffect(() => {
    setFocusedTableIndex(-1);
  }, [activeChip, searchTerm]);

  const currentFloorAreaLayouts = useMemo(() => {
    if (!selectedFloor?.parentValue) return [];
    const floorData = multiLevelData?.find(
      (floor) => floor?.levelOneId === selectedFloor?.parentValue
    );
    const orderedAreas = floorData?.levelTwo || [];
    return orderedAreas.map((area) => {
      const areaLayout = allAreasLayouts?.[area.value] || {
        mapId: area.value,
        entityName: area.label,
        children: [],
      };
      const filteredChildren = (areaLayout?.children || [])
        .filter((table) => table?.status !== "BLOCKED")
        .filter((table) => {
          if (activeChip === "AVAILABLE") return table?.status === "AVAILABLE";
          if (activeChip === "OCCUPIED")
            return (
              table?.status === "OCCUPIED" &&
              table?.cartStatus !== "ORDER_CREATED" &&
              table?.cartStatus !== "PAYMENT_PENDING"
            );
          if (activeChip === "ORDER_CREATED") return table?.cartStatus === "ORDER_CREATED";
          return true;
        })
        .filter((table) =>
          searchTerm
            ? table?.metadata?.tableName?.toLowerCase().includes(searchTerm?.toLowerCase())
            : true
        );
      return {
        ...areaLayout,
        totalTables:
          areaLayout?.children?.filter((table) => table?.status !== "BLOCKED")?.length || 0,
        filteredChildren,
      };
    });
  }, [activeChip, allAreasLayouts, multiLevelData, searchTerm, selectedFloor]);

  // Tables the status chips count — must mirror what the board renders, not just one area
  const badgeTables = useMemo(
    () =>
      (selectedAreaId === null
        ? currentFloorAreaLayouts?.flatMap((area) => area?.children || [])
        : selectedLayout?.children || []
      )?.filter((t) => t?.status !== "BLOCKED"),
    [selectedAreaId, currentFloorAreaLayouts, selectedLayout]
  );

  // Unified navigable table list — works in both All-areas and single-area modes
  const navigableTables = useMemo(() => {
    if (selectedAreaId !== null) return filteredTables;
    return currentFloorAreaLayouts?.flatMap((area) => area.filteredChildren || []);
  }, [selectedAreaId, filteredTables, currentFloorAreaLayouts]);

  // mapId → index for O(1) focus lookup when rendering All-areas mode
  const navigableIndexByMapId = useMemo(() => {
    const map = {};
    navigableTables?.forEach((t, i) => {
      map[t.mapId] = i;
    });
    return map;
  }, [navigableTables]);

  // Active waiter-task requests, keyed for O(1) lookup per table card. Keyed
  // by "areaName||tableName" first — All-areas mode can render two same-named
  // tables from different areas at once, so a name-only key would badge both.
  // Falls back to a name-only key only when that name is unambiguous across
  // the current poll response; otherwise shows no badge (fail-closed) rather
  // than risk attaching a request to the wrong table.
  const tableTasksByKey = useMemo(() => {
    // Same read-tracking localStorage key the navbar's Live Updates panel
    // uses (posnavbar/index.js) — a request already acknowledged there
    // shouldn't also show a badge here. Read fresh each recompute rather
    // than tracking it as separate state, so it stays in step with
    // tableTasks (every poll tick / on-demand refresh) with no extra wiring.
    let readIds;
    try {
      readIds = new Set(JSON.parse(localStorage.getItem("islandReadIds") || "[]"));
    } catch {
      readIds = new Set();
    }

    const byAreaAndName = {};
    const nameOccurrences = {};

    (tableTasks || [])?.forEach((entry) => {
      const requests = (entry?.tasks || [])
        ?.filter((task) => TASK_ACTION_TO_TYPE[task?.taskAction] && !readIds?.has(task?.taskId))
        ?.map((task) => ({
          type: TASK_ACTION_TO_TYPE[task.taskAction],
          taskId: task?.taskId,
          requestedAt:
            task?.requestedDate && task?.requestedAt
              ? `${task?.requestedDate}T${task?.requestedAt}`
              : null,
        }));
      if (!requests?.length) return;
      byAreaAndName[`${entry?.areaName || ""}||${entry?.tableName || ""}`] = requests;
      nameOccurrences[entry?.tableName] = (nameOccurrences[entry?.tableName] || 0) + 1;
    });

    const byNameIfUnique = {};
    (tableTasks || [])?.forEach((entry) => {
      const key = `${entry?.areaName || ""}||${entry?.tableName || ""}`;
      if (byAreaAndName[key] && nameOccurrences[entry?.tableName] === 1) {
        byNameIfUnique[entry?.tableName] = byAreaAndName[key];
      }
    });

    return { byAreaAndName, byNameIfUnique };
    // readIdsVersion isn't read in the body above — it only bumps when
    // islandReadIds actually changed, forcing a recompute at that point
    // instead of waiting for the next tableTasks poll tick.
  }, [tableTasks, readIdsVersion]);

  const getActiveRequestsForTable = useCallback(
    (areaEntityName, tableName) => {
      if (!tableName) return null;
      return (
        tableTasksByKey?.byAreaAndName[`${areaEntityName || ""}||${tableName}`] ||
        tableTasksByKey?.byNameIfUnique[tableName] ||
        null
      );
    },
    [tableTasksByKey]
  );

  // Scroll focused table into view when index changes
  useEffect(() => {
    if (focusedTableIndex < 0) return;
    const table = navigableTables[focusedTableIndex];
    if (!table) return;
    tableRefs.current[table.mapId]?.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest",
    });
  }, [focusedTableIndex, navigableTables]);

  // Keyboard shortcuts for table layout page
  useEffect(() => {
    const handleKeyDown = (e) => {
      const isInputFocused = ["INPUT", "TEXTAREA", "SELECT"].includes(e.target.tagName);
      if (isInputFocused) return;

      const { key, ctrlKey, altKey, shiftKey } = e;

      // F5 → Refresh table layout
      if (key === "F5") {
        e.preventDefault();
        refreshTableLayout();
        return;
      }

      // Ctrl+G → Toggle grid / coordinate view
      if (ctrlKey && key.toLowerCase() === "g") {
        e.preventDefault();
        setViewMode((prev) => (prev === "grid" ? "coordinate" : "grid"));
        return;
      }

      // Ctrl+F → Toggle floor selector bar
      if (ctrlKey && key.toLowerCase() === "f") {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent("tableLayout:toggleFloorBar"));
        return;
      }

      // Ctrl+Shift+1~4 → Toggle filter chips
      if (ctrlKey && shiftKey) {
        const filterMap = { 1: "AVAILABLE", 2: "OCCUPIED", 3: "ORDER_CREATED" };
        if (filterMap[key]) {
          e.preventDefault();
          setActiveChip((prev) => (prev === filterMap[key] ? null : filterMap[key]));
          return;
        }
      }

      // Ctrl+1–9 → Jump to floor by index (1-based)
      if (ctrlKey && !shiftKey && !altKey) {
        const floorIndex = parseInt(key, 10);
        if (!isNaN(floorIndex) && floorIndex >= 1 && floorIndex <= 9) {
          const targetFloor = floorPlan[floorIndex - 1];
          if (targetFloor) {
            e.preventDefault();
            handleFloorChange({
              label: targetFloor.label,
              value: targetFloor.value,
              parentLabel: targetFloor.label,
              parentValue: targetFloor.value,
            });
            showSnackbar(`Floor: ${targetFloor.label}`, "info");
          }
          return;
        }
      }

      // [ / ] → cycle through areas of current floor (All → AC → Non AC → …)
      if (!ctrlKey && !altKey && !shiftKey && (key === "[" || key === "]")) {
        const floorData = multiLevelData?.find((f) => f.levelOneId === selectedFloor?.parentValue);
        const areas = floorData?.levelTwo || [];
        if (areas.length < 2) return;
        e.preventDefault();

        const areaList = [null, ...areas.map((a) => a?.value)];
        const currentIdx = areaList?.indexOf(selectedAreaId);
        const nextIdx =
          key === "]"
            ? (currentIdx + 1) % areaList?.length
            : (currentIdx - 1 + areaList?.length) % areaList?.length;
        handleAreaTabChange(areaList[nextIdx]);

        const label =
          areaList[nextIdx] === null
            ? "All"
            : areas?.find((a) => a.value === areaList[nextIdx])?.label || "";
        showSnackbar(`Area: ${label}`, "info");
        return;
      }

      // Escape → blur any focused interactive element first, then deselect table / clear filter
      if (key === "Escape" && !ctrlKey && !shiftKey) {
        const activeEl = document.activeElement;
        if (activeEl && activeEl !== document.body) {
          activeEl.blur();
          return;
        }
        if (focusedTableIndex >= 0) {
          setFocusedTableIndex(-1);
        } else if (activeChip) {
          setActiveChip(null);
        }
        return;
      }

      // Arrow keys → navigate between tables (only in DINE_IN mode)
      if (saleMode !== "DINE_IN") return;

      if (key === "ArrowRight" || key === "ArrowDown") {
        e.preventDefault();
        setFocusedTableIndex((prev) =>
          navigableTables?.length === 0 ? -1 : prev < navigableTables?.length - 1 ? prev + 1 : 0
        );
        return;
      }

      if (key === "ArrowLeft" || key === "ArrowUp") {
        e.preventDefault();
        setFocusedTableIndex((prev) =>
          navigableTables?.length === 0 ? -1 : prev > 0 ? prev - 1 : navigableTables?.length - 1
        );
        return;
      }

      // Enter → select the focused table
      if (key === "Enter" && focusedTableIndex >= 0) {
        e.preventDefault();
        const table = navigableTables[focusedTableIndex];
        if (table) {
          // Find the area name for this table (needed for cart creation)
          const areaName =
            selectedAreaId !== null
              ? selectedLayout?.entityName
              : currentFloorAreaLayouts?.find((a) =>
                  a?.filteredChildren?.some((t) => t?.mapId === table?.mapId)
                )?.entityName;
          handleTableSelection(table, areaName);
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [
    activeChip,
    focusedTableIndex,
    navigableTables,
    saleMode,
    selectedLayout,
    floorPlan,
    multiLevelData,
    selectedFloor,
    selectedAreaId,
    handleFloorChange,
    handleAreaTabChange,
    currentFloorAreaLayouts,
  ]);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem(LAST_SELECTED_TABLE_KEY));
    if (stored?.tableMapId && stored?.layoutId === selectedLayout?.mapId) {
      setLastSelectedTableId(stored?.tableMapId);
    } else {
      setLastSelectedTableId(null);
    }
  }, [selectedLayout]);

  const calculateTablePosition = (table) => {
    const baseX = parseFloat(table?.tableMetadata?.xaxis) || 0;
    const baseY = parseFloat(table?.tableMetadata?.yaxis) || 0;

    // Grid size - tables will snap to this grid
    const GRID_SIZE = 110; // Size of each grid cell (adjust as needed)
    const PADDING = 10; // Padding within each grid cell

    // Calculate which grid cell this table belongs to
    const gridX = Math.floor(baseX / 100) * GRID_SIZE + PADDING;
    const gridY = Math.floor(baseY / 100) * GRID_SIZE + PADDING;

    return {
      x: gridX,
      y: gridY,
    };
  };

  const areaTitle = selectedLayout?.entityName || "AC";
  const areaStats = useMemo(() => {
    const totalTables = selectedLayout?.children?.length || 0;
    const availableTables =
      selectedLayout?.children?.filter((table) => table?.status === "AVAILABLE")?.length || 0;
    return {
      totalTables,
      availableTables,
    };
  }, [selectedLayout]);

  useEffect(() => {
    const tables = selectedLayout?.children?.filter((t) => t?.status !== "BLOCKED") || [];
    const occupiedTables = tables.filter((t) => t?.status !== "AVAILABLE");
    const totalSeats = tables.reduce((sum, t) => sum + (t?.metadata?.capacity || 0), 0);
    const occupiedSeats = occupiedTables.reduce((sum, t) => sum + (t?.metadata?.capacity || 0), 0);
    const kotCount = tables.filter(
      (t) => t?.cartStatus === "ORDER_CREATED" || t?.cartStatus === "ORDER_PLACED"
    ).length;
    setTableLayoutStats({
      totalTables: tables.length,
      occupiedTables: occupiedTables.length,
      totalSeats,
      occupiedSeats,
      kotCount,
    });
    return () => setTableLayoutStats(null);
  }, [selectedLayout, setTableLayoutStats]);

  const renderTableCard = useCallback(
    (table, areaEntityName, isKeyboardFocused = false) => {
      if (!tableRefs.current[table?.mapId]) {
        tableRefs.current[table?.mapId] = React.createRef();
      }

      const activeRequests = getActiveRequestsForTable(areaEntityName, table?.metadata?.tableName);

      return (
        <div
          key={table?.mapId}
          ref={tableRefs.current[table?.mapId]}
          style={{
            position: "relative",
            ...(viewMode === "coordinate"
              ? {
                  position: "absolute",
                  top: `${table?.metadata?.yaxis}px`,
                  left: `${table?.metadata?.xaxis}px`,
                }
              : {}),
            borderRadius: "12px",
            padding: "4px",
            outline:
              table?.mapId === lastSelectedTableId
                ? "2px solid #0860E6"
                : isKeyboardFocused
                ? "2.5px solid #0860E6"
                : "none",
            boxShadow:
              table?.mapId === lastSelectedTableId
                ? "0 0 0 4px rgba(8,96,230,0.12)"
                : isKeyboardFocused
                ? "0 0 0 4px rgba(8,96,230,0.15)"
                : "none",
          }}
        >
          {/* Card click zone — clicking here selects the table.
              Action buttons are siblings of this div, so their clicks
              never bubble here; no stopPropagation needed. */}
          <div
            style={{ position: "relative", cursor: "pointer" }}
            onClick={() => handleTableSelection(table, areaEntityName)}
          >
            {table?.mapId === lastSelectedTableId && (
              <span className="ts-last-accessed-badge">LAST ACCESSED</span>
            )}
            <TableStructure
              name={table?.metadata?.tableName}
              seat={table?.metadata?.capacity}
              status={table?.status}
              cartStatus={table?.cartStatus}
              tableSelectionLoader={tableSelectionLoader[table?.mapId] || false}
              totalCartValue={table?.totalCartValue}
              kitchenCount={table?.kitchenCount}
              elapsedMinutes={
                table?.createdDate
                  ? calculateTimeDifference(table.createdDate)
                  : table?.elapsedMinutes ||
                    table?.occupiedMinutes ||
                    table?.timeElapsedMinutes ||
                    null
              }
              reservedTime={table?.metadata?.reservationTime || table?.reservedTime || null}
            />
            <TableKitchenTiming table={table} />
            {!!activeRequests?.length && <RequestBadgeCluster requests={activeRequests} />}
          </div>
          {isTableOccupied(table?.status) &&
            table?.cartStatus &&
            table?.cartStatus !== "CREATED" && (
              <div className="ts-action-btns">
                {(table?.cartStatus === "ORDER_PLACED" ||
                  table?.cartStatus === "ORDER_CREATED" ||
                  table?.cartStatus === "PAYMENT_PENDING") && (
                  <button
                    className={`ts-icon-btn ${
                      table?.cartStatus === "ORDER_PLACED"
                        ? "ts-icon-btn--occupied"
                        : "ts-icon-btn--payment"
                    }`}
                    disabled={!!tableActionLoader[table?.mapId]}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleTablePrintBill(table);
                    }}
                    title="Print Bill"
                  >
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="6 9 6 2 18 2 18 9" />
                      <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                      <rect x="6" y="14" width="12" height="8" />
                    </svg>
                  </button>
                )}
                {(table?.cartStatus === "ORDER_PLACED" ||
                  table?.cartStatus === "ORDER_CREATED" ||
                  table?.cartStatus === "PAYMENT_PENDING") && (
                  <button
                    className="ts-icon-btn ts-icon-btn--payment"
                    disabled={!!tableActionLoader[table?.mapId]}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleTableRecordPayment(table);
                    }}
                    title="Record Payment"
                  >
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
                      <line x1="1" y1="10" x2="23" y2="10" />
                    </svg>
                  </button>
                )}
              </div>
            )}
        </div>
      );
    },
    [
      getActiveRequestsForTable,
      handleTablePrintBill,
      handleTableRecordPayment,
      handleTableSelection,
      lastSelectedTableId,
      tableActionLoader,
      tableSelectionLoader,
      viewMode,
    ]
  );

  const tableCards = useMemo(
    () =>
      filteredTables?.map((table, index) =>
        renderTableCard(table, selectedLayout?.entityName, focusedTableIndex === index)
      ),
    [filteredTables, focusedTableIndex, renderTableCard, selectedLayout]
  );

  return (
    <TableServingTimingProvider>
    <Navbar>
      <div className="table-container">
        <SecondaryTopbar
          activeChip={activeChip}
          setActiveChip={setActiveChip}
          onClickFunction={handleShowOrderModal}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          floorPlan={floorPlan}
          selectedFloor={selectedFloor}
          onFloorChange={handleFloorChange}
          selectedAreaId={selectedAreaId}
          onAreaChange={handleAreaTabChange}
          floorCapacity={floorCapacity}
          multiLevelData={multiLevelData}
          loader={loader}
          viewMode={viewMode}
          setViewMode={setViewMode}
          allTables={badgeTables}
        />

        <div style={{ position: "relative" }}>
          {tablesLoading && (
            <div
              style={{
                position: "fixed",
                top: "104px" /* 56px main navbar + 48px secondary topbar */,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(255, 255, 255, 0.5)",
                backdropFilter: "blur(4px)",
              }}
            >
              <CircularProgress size={32} />
            </div>
          )}
          {!tablesLoading && statusRefreshing && (
            <div
              style={{
                position: "absolute",
                top: "8px",
                right: "12px",
                zIndex: 20,
                display: "flex",
                alignItems: "center",
                gap: "6px",
                background: "rgba(255, 255, 255, 0.9)",
                padding: "4px 10px",
                borderRadius: "12px",
                boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                fontSize: "11px",
                color: "#666",
              }}
            >
              <CircularProgress size={10} sx={{ color: "#888" }} />
              Refreshing status...
            </div>
          )}

          <div
            className={`tableStructureBoard ${
              viewMode === "grid" ? "grid-view" : "coordinate-view"
            }`}
            style={{
              filter: saleMode !== "DINE_IN" ? "blur(4px)" : "none",
              opacity: saleMode !== "DINE_IN" ? 0.5 : 1,
              pointerEvents: saleMode !== "DINE_IN" ? "none" : "auto",
              transition: "filter 0.3s ease, opacity 0.3s ease",
            }}
          >
            {selectedAreaId === null ? (
              // ── All-areas mode: render each area with its own header + tables ──
              <>
                {currentFloorAreaLayouts.map((areaLayout) => {
                  if (!areaLayout?.mapId) return null;
                  return (
                    <section key={areaLayout.mapId} className="table-layout-area-section">
                      <div className="table-layout-area-header">
                        <div className="table-layout-area-heading">
                          <h3 className="table-layout-area-title">{areaLayout.entityName}</h3>
                          <div className="table-layout-area-line" />
                        </div>
                        <span className="table-layout-area-pill">
                          {areaLayout?.children?.filter(
                            (t) => t?.status === "AVAILABLE" && t?.status !== "BLOCKED"
                          )?.length || 0}
                          /{areaLayout?.totalTables} AVAILABLE
                        </span>
                      </div>
                      <div className="table-layout-area-grid">
                        {areaLayout?.filteredChildren?.map((table) =>
                          renderTableCard(
                            table,
                            areaLayout?.entityName,
                            navigableIndexByMapId[table.mapId] === focusedTableIndex &&
                              focusedTableIndex >= 0
                          )
                        )}
                      </div>
                    </section>
                  );
                })}
                <div className="table-layout-branding">
                  <h2>
                    Every Table,
                    <br />
                    Every Moment!
                  </h2>
                  <p>
                    Crafted with <span>❤</span> for hospitality heroes
                  </p>
                </div>
              </>
            ) : (
              // ── Single-area mode ──
              <>
                <div className="table-layout-area-header">
                  <div className="table-layout-area-heading">
                    <h3 className="table-layout-area-title">{areaTitle}</h3>
                    <div className="table-layout-area-line" />
                  </div>
                  <span className="table-layout-area-pill">
                    {areaStats?.availableTables}/{areaStats?.totalTables} AVAILABLE
                  </span>
                </div>
                <div className="table-layout-area-grid">{selectedLayout && tableCards}</div>
                <div className="table-layout-branding">
                  <h2>
                    Every Table,
                    <br />
                    Every Moment!
                  </h2>
                  <p>
                    Crafted with <span>❤</span> for hospitality heroes
                  </p>
                </div>
              </>
            )}
          </div>

          {saleMode !== "DINE_IN" && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                background: "rgba(255, 255, 255, 0.95)",
                padding: "24px 32px",
                borderRadius: "8px",
                textAlign: "center",
                fontWeight: "500",
                fontSize: "16px",
                color: "#333",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                zIndex: 10,
                pointerEvents: "none",
              }}
            >
              Please select "Dine In" to view and select tables
            </div>
          )}
        </div>

        {/* <div className="tableLayoutBottombar">
          {cloudPrint && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "8px 12px",
                borderRadius: "6px",
                marginRight: "10px",
                backgroundColor: isPrinterOnlineForLocation ? "#e8f5e9" : "#ffebee",
                border: `1px solid ${isPrinterOnlineForLocation ? "#a5d6a7" : "#ef9a9a"}`,
              }}
            >
              <div
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: isPrinterOnlineForLocation ? "#4caf50" : "#f44336",
                }}
              />
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  color: isPrinterOnlineForLocation ? "#2e7d32" : "#c62828",
                }}
              >
                Printer: {isPrinterOnlineForLocation ? "Connected" : "Disconnected"}
              </span>
            </div>
          )}
          <div className="tableBottombarRight">
            <div className="bottombar-icon-btn" onClick={() => handleBottomButtonClick("returns")}>
              <RepartitionIcon style={{ fontSize: "20px", color: "#535861" }} />
              <span>Returns</span>
            </div>

            <div className="bottombar-icon-btn" onClick={() => handleBottomButtonClick("settings")}>
              <Cog8ToothIcon style={{ width: "20px", height: "20px", color: "#535861" }} />
              <span>Settings</span>
            </div>

            <div className="bottombar-icon-btn" onClick={() => handleBottomButtonClick("sessions")}>
              <LayersOutlinedIcon style={{ fontSize: "20px", color: "#535861" }} />
              <span>Sessions</span>
            </div>

            {!isMobileView && (
              <div
                className="bottombar-icon-btn"
                onClick={() => handleBottomButtonClick("inventory")}
              >
                <ChartPieIcon style={{ width: "20px", height: "20px", color: "#535861" }} />
                <span>Inventory</span>
              </div>
            )}

            <div className="bottombar-icon-btn" onClick={() => handleBottomButtonClick("ods")}>
              <LocalShippingOutlinedIcon style={{ fontSize: "20px", color: "#535861" }} />
              <span>ODS</span>
            </div>

            {!isMobileView && isKDSRequired && (
              <div className="bottombar-icon-btn" onClick={() => handleBottomButtonClick("kds")}>
                <img src={orderDisplayIcon} alt="KDS" style={{ width: "20px", height: "20px" }} />
                <span>KDS</span>
              </div>
            )}

            <div
              className="bottombar-icon-btn"
              onClick={() => handleBottomButtonClick("tableOrdering")}
            >
              <TableCellsIcon style={{ width: "20px", height: "20px", color: "#535861" }} />
              <span>Table Order</span>
            </div>

            <div className="bottombar-icon-btn" onClick={() => handleBottomButtonClick("menu")}>
              <ToggleOffOutlinedIcon style={{ width: "20px", height: "20px", color: "#535861" }} />
              <span>Menu</span>
            </div>

            {!isMobileView && (
              <div
                className="bottombar-icon-btn"
                onClick={() => handleBottomButtonClick("reservations")}
              >
                <DocumentPlusIcon style={{ width: "20px", height: "20px", color: "#535861" }} />
                <span>Reservations</span>
              </div>
            )}

            <div className="bottombar-icon-btn" onClick={() => handleBottomButtonClick("orders")}>
              <ClipboardDocumentListIcon
                style={{ width: "20px", height: "20px", color: "#535861" }}
              />
              <span>Orders</span>
            </div>
          </div>
        </div> */}

        <TableDetailsModal
          tableDetailsModalOpen={tableDetailsModalOpen}
          setTableDetailsModalOpen={setTableDetailsModalOpen}
          selectedTableMapId={selectedTableMapId}
          setCanceledTable={setCanceledTable}
        />

        <TableConfirmationModal
          tableConfirmationModalOpen={tableConfirmationModalOpen}
          setTableConfirmationModalOpen={setTableConfirmationModalOpen}
          tableName={pendingTableData?.metadata?.tableName || ""}
          capacity={pendingTableData?.metadata?.capacity || 2}
          onConfirm={({ pax }) => {
            const updatedTable = {
              ...pendingTableData,
              layoutName: pendingLayoutName,
              tableNoForDisplay: pendingTableData?.metadata?.tableName,
              pax,
            };
            localStorage.setItem(
              LAST_SELECTED_TABLE_KEY,
              JSON.stringify({
                tableMapId: updatedTable?.mapId,
                layoutId: selectedLayout?.mapId,
              })
            );
            setTableSelectionLoader((prev) => ({ ...prev, [updatedTable?.mapId]: true }));
            setSelectedTable(updatedTable);
            localStorage.setItem("selectedTableData", JSON.stringify(updatedTable));
            setTableConfirmationModalOpen(false);
            createCartFromTable(updatedTable, pendingLayoutName);
          }}
        />

        <TakeawayDeliveryModal
          open={orderDetailsModalOpen}
          mode={pendingOrderMode}
          onClose={() => setOrderDetailsModalOpen(false)}
          onSkip={() =>
            Promise.resolve(handleNextClick(pendingOrderMode)).finally(() =>
              setOrderDetailsModalOpen(false)
            )
          }
          onConfirm={(customerData) =>
            Promise.resolve(handleNextClick(pendingOrderMode, customerData)).finally(() =>
              setOrderDetailsModalOpen(false)
            )
          }
        />

        {/* Table Payment Modal - same as Cart.js */}
        <PaymentModal
          variant="restaurant"
          openPayModal={paymentModalOpen}
          closePaymentModal={closeTablePaymentModal}
          cartItems={tpCartItems}
          total={tpTotal}
          orderSummary={tpOrderSummary}
          showOnlyGrandTotal={true}
          paymentMethod={tpPaymentMethod}
          setPaymentMethod={setTpPaymentMethod}
          enterAmount={tpEnterAmount}
          setEnterAmount={setTpEnterAmount}
          enterAmountRef={tpEnterAmountRef}
          checkPayment={tpCheckPayment}
          partialCompletePayment={() => tpPartialCompletePayment()}
          splitActive={tpSplitActive}
          setSplitActive={setTpSplitActive}
          handleSplitPayment={tpHandleSplitPayment}
          handlesplitInputChange={tpHandleSplitInputChange}
          partialStatus={tpPartialStatus}
          setPartailStatus={setTpPartialStatus}
          amountPaid={tpAmountPaid}
          amountDue={tpAmountDue}
          cashChange={tpCashChange}
          newLoader={tpNewLoader}
          modalLoader={tpModalLoader}
          payLoader={tpPayLoader}
          paymentLoader={tpPaymentLoader}
          paymentLoadingModal={false}
          canceledOnce={false}
          paymentSuccess={tpPaymentSuccess}
          setPaymentSuccess={setTpPaymentSuccess}
          paymentFailed={tpPaymentFailed}
          paymentCancel={tpPaymentCancel}
          manual={tpManual}
          cancelLoader={tpCancelLoader}
          newId={tpNewId}
          orderId={tpNewId}
          isError={isError}
          isPrinting={isPrinting}
          adjustCheck={false}
          amtToBePaid={0}
          amtHeading={"Payable Amount"}
          storeMode={"ONLINE"}
          singleOrderoffline={false}
          resetValues={tpResetValues}
          setpaymentLoader={setTpPaymentLoader}
          setOpen={() => {}}
          setPackingCharge={() => {}}
          setDeliveryCharge={() => {}}
          handleOpenPaymentModal={() => {}}
          handleOptionChange={() => {}}
          setOpenCartCustomerDetail={() => {}}
          setShowFineDineActionButtons={() => {}}
          handleManual={() => setTpManual(true)}
          handleManualorders={() => {}}
          handleTansactionCancel={() => {
            setTpPaymentFailed(false);
            setTpPaymentCancel(false);
            setTpPaymentLoader(false);
          }}
          functionCalled={false}
          setFunctionCalled={() => {}}
          cardFunctionCalled={false}
          setCardFunctionCalled={() => {}}
          splitFunctionCalled={false}
          setSplitFunctionCalled={() => {}}
          cashierPin={""}
          approveloader={false}
          transCode={""}
          newTransId={""}
          cancelTrans={false}
          cancelSingle={false}
          failedImgWarning={""}
          cancelGif={""}
          cashIcon={cashNew}
          cashIconSelected={cashNewSelected}
          upiIcon={upiNew}
          upiIconSelected={upiNewSelected}
          cardIcon={cardNew}
          cardIconSelected={cardNewSelected}
          creditIcon={cashNew}
          creditIconSelected={cashNewSelected}
          splitImg={splitNew}
          splitImgSelected={splitNewSelected}
          offlineImg={""}
          handleOffline={() => {}}
          clrAmountFun={() => setTpEnterAmount("")}
          setAmtFocus={() => {}}
          hideSplitPayment={false}
          hideSodexo={true}
        />

        <MenuAvailabilityDrawer
          open={menuAvailabilityOpen}
          onClose={() => setMenuAvailabilityOpen(false)}
        />
      </div>
    </Navbar>
    </TableServingTimingProvider>
  );
};

export default RestaurantReservationUI;
